import { db, storage } from "../../firebase/config"
import { useAuthContext } from "../../hooks/useAuthContext"
import {
  collection,
  doc,
  addDoc,
  getDocs,
  getDoc,
  query,
  orderBy,
  serverTimestamp,
  where,
  updateDoc,
  onSnapshot,
  setDoc,
  arrayUnion,
  writeBatch,
} from "firebase/firestore"

// import AntDesign
import {
  Col,
  Divider,
  Row,
  Select,
  Space,
  Tooltip,
  InputNumber,
  Typography,
  Progress,
  Button,
  Tabs,
  Skeleton,
  Input,
  message,
  Upload,
  Popconfirm,
  Spin,
  Checkbox,
} from "antd"

//import icons from antd
import {
  CalculatorOutlined,
  CheckCircleFilled,
  FileOutlined,
  InfoCircleFilled,
  InfoCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons"

import { useEffect, useState } from "react"
import { Notification } from "../../components/Notification"
import CalculationsPopup from "../../components/Manager/Calculations/CalculationsPopup"
import {
  deleteObject,
  getDownloadURL,
  ref,
  uploadBytes,
  uploadBytesResumable,
} from "firebase/storage"
import { useLocation, useNavigate } from "react-router-dom"
import FlexoFields from "../../components/Calculation/FlexoFields"
import TapeLayout from "../../components/Calculation/TapeLayout"
import { TapeTab } from "../../components/Calculation/TabsContent"
import FlexoPriceSection from "../../components/Calculation/PriceSection/FlexoPriceSection"
import TapePriceSection from "../../components/Calculation/PriceSection/TapePriceSection"
import SelectClient from "../../components/Calculation/Fields/SelectClient"
import AdminCommentModal from "../../components/Calculation/AdminComment/AdminCommentModal"
import axiosInstance from "../../axios/axiosConfig"
import SelectProductType from "../../components/Calculation/Fields/SelectProductType"

const { Option } = Select
const { Text, Title, Link } = Typography

export default function Calculations() {
  //user from auth context
  const { user, admin, semiAdmin, devSpecialist } = useAuthContext()

  // get user specific updates for a price
  // such as extra percent for a user
  const [userExtraPercent, setUserExtraPercent] = useState(0)
  const [fromAdminState, setFromAdminState] = useState(false)

  //navigation
  const navigate = useNavigate()

  // gets the data from the link
  const location = useLocation()

  //whole state
  const totalState = location.state

  // location state
  let dataFromState

  if (location.state && location.state.changedByDesigner) {
    dataFromState = location.state.selectedProduct
  } else {
    dataFromState = location.state
  }

  //Machines
  const [machines, setMachines] = useState(null)
  const [selectedMachine, setSelectedMachine] = useState(null)
  const [machineSpeed, setMachineSpeed] = useState(0)
  const [machineStations, setMachineStations] = useState(0)
  const [machineAlsm, setMachineAlsm] = useState(0)
  const [machineElectricity, setMachineElectricity] = useState(0)
  const [machineWorker, setMachineWork] = useState(0)
  const [machineAmortization, setMachineAmortization] = useState(0)

  //Clients
  const [clients, setClients] = useState([])
  const [selectedClient, setSelectedClient] = useState(null)
  const [clientsProfit, setClientsProfit] = useState(0)
  const [loadingClients, setLoadingClients] = useState(true)
  const [selectedClientId, setSelectedClientId] = useState(0)
  const [selectedClientName, setSelectedClientName] = useState("none")
  const [extraProfitSlider, setExtraProfitSlider] = useState(0)
  const [clientisLead, setClientIsLead] = useState(false)

  // //Products
  const [productName, setProductName] = useState(null)
  const [productFile, setProductFile] = useState(null)

  //Label Settings
  const [labelCount, setLabelCount] = useState(0)
  const [labelHeight, setLabelHeight] = useState(0)
  const [labelWidth, setLabelWidth] = useState(0)
  const [rowBalance, setRowBalance] = useState(0)

  //Material
  const [material, setMaterial] = useState(0)
  const [materialEurM2, setMaterialEurM2] = useState(0)
  const [materialGM2, setMaterialGM2] = useState(0)
  const [selectedMaterial, setSelectedMaterial] = useState("none")
  const [materialLoading, setMaterialLoading] = useState(false)
  const [selectedMaterialId, setSelectedMaterialId] = useState(null)

  //Format width
  const [formatWidth, setFormatWidth] = useState(0)
  const [formatWidthList, setFormatWidthList] = useState([])

  //Number of columns
  const [numberOfColumns, setNumberOfColumns] = useState(0)

  //CMYK
  const [cmykColors, setCmykColors] = useState(0)
  const [cmykPercent, setCmykPercent] = useState(1)

  //Pantone
  const [pantoneColors, setPantoneColors] = useState(0)
  const [pantonePercent, setPantonePercent] = useState(0)

  //Covering W
  const [coveringWCount, setCoveringWCount] = useState(0)
  const [coveringWPercent, setCoveringWPercent] = useState(0)

  //Varnish
  const [varnish, setVarnish] = useState(0)
  const [varnishType, setVarnishType] = useState("none")
  const [varnishXpretp, setVarnishXpretp] = useState(0)
  // const [varnishCost, setVarnishCost] = useState(0);
  const [varnishUse, setVarnishUse] = useState(0)
  const [varnishPercent, setVarnishPercent] = useState(1)
  const [selectedVarnish, setSelectedVarnish] = useState("none")
  const [selectedVarnishId, setSelectedVarnishId] = useState(null)

  //Gold or Silver
  const [goldOrSilver, setGoldOrSilver] = useState(0)
  const [goldOrSilverPercent, setGoldOrSilverPercent] = useState(0)

  //Relief
  const [relief, setRelief] = useState(null)
  const [reliefMeters, setReliefMeters] = useState(0)
  const [reliefRunningMeters, setReliefRunningMeters] = useState(0)
  const [reliefTimePerMin, setReliefTimePerMin] = useState(0)
  const [selectedReliefValue, setSelectedReliefValue] = useState(0)
  const [selectedReliefUse, setSelectedReliefUse] = useState(0)
  const [selectedRelief, setSelectedRelief] = useState("No")
  const [selectedReliefId, setSelectedReliefId] = useState(null)

  //Foil
  const [foil, setFoil] = useState(null)
  const [foilCount, setFoilCount] = useState(0)
  const [foilCosts, setFoilCosts] = useState(0)
  const [foilColor, setFoilColor] = useState("none")
  const [foilPercent, setFoilPercent] = useState(0)
  const [selectedFoilColor, setSelectedFoilColor] = useState("none")
  const [selectedFoilId, setSelectedFoilId] = useState(null)

  //Production1
  const [productionCosts, setProductionCosts] = useState(0)
  // const [productionAdjustRunningMeters, setProductionAdjustRunningMeters] = useState(0);
  const [productionRunningMetersMin, setProductionRunningMetersMin] = useState(0)
  const [productionTimePerMinute, setProductionTimePerMinute] = useState(0)
  const [selectedProductionMachine, setSelectedProductionMachine] = useState("")
  const [selectedProductionMachineId, setSelectedProductionMachineId] = useState(0)

  //product file list
  const [fileList, setFileList] = useState([])

  //Production2
  const [productionCosts2, setProductionCosts2] = useState(0)
  // const [productionAdjustRunningMeters2, setProductionAdjustRunningMeters2] = useState(0);
  const [productionRunningMetersMin2, setProductionRunningMetersMin2] = useState(0)
  const [productionTimePerMinute2, setProductionTimePerMinute2] = useState(0)
  const [selectedProductionMachine2, setSelectedProductionMachine2] = useState("")
  const [selectedProductionMachine2Id, setSelectedProductionMachine2Id] = useState(0)

  //Rastra
  const [rastra, setRastra] = useState(0)

  //Total Price
  const [totalPrice, setTotalPrice] = useState(0)
  const [fixedPrice, setFixedPrice] = useState(false)
  const [totalFixedPrice, setTotalFixedPrice] = useState(0)
  const [disableFixedPriceButton, setDisableFixedPriceButton] = useState(true)

  //Knives
  //init button text for selecting knives
  const initalKniveButtonText = "Select"
  // const [knives, setKnives] = useState([]);
  const [kniveSpaceBetweenRows, setKniveSpaceBetweenRows] = useState(3)
  const [kniveGapRaport, setKniveGapRaport] = useState(3)
  const [selectedKnifeCode, setSelectedKnifeCode] = useState("none")
  const [selectedKnifeId, setSelectedKnifeId] = useState("none")
  const [kniveButtonText, setKniveButtonText] = useState(initalKniveButtonText)

  //comment
  const [userComment, setUserComment] = useState("")

  //function for handling fixed price
  const handleFixedPrice = () => {
    setFixedPrice((prev) => !prev)
    setDisableFixedPriceButton((prev) => !prev)
  }

  //Total Weight
  const [labelWeight, setTotalLabeWeight] = useState(0)

  //visibility for advanced panel
  const [visible, setVisible] = useState(false)

  //sets the active key from machine select to tabs
  const [activeKey, setActiveKey] = useState("1")

  //sets the visibility of the tooltip for RowBalance
  const [tooltipRowBalance, setTooltipRowBalance] = useState(false)

  //sets save buttons state
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(true)

  //How many times will machine go trought
  const [howManyTimes, setHowManyTimes] = useState(1)

  const [totalPointsRemaining, setTotalPointsRemaining] = useState(0)
  const [pointsRemaining, setPointsRemaining] = useState(0)

  // Krasu paterins (Color spent)
  const [krasuPaterinsCMYK, setKrasuPaterinsCMYK] = useState()
  const [krasuPaterinsPantone, setKrasuPaterinsPantone] = useState()
  const [krasuPaterinsLaka, setKrasuPaterinsLaka] = useState()
  const [krasuPaterinsZeltaKrasa, setKrasuPaterinsZeltaKrasa] = useState()

  //krasu cenas eur kg (color prices eur/kg)
  const [krasuCenaEurKgLaka, setKrasuCenaEurKgLaka] = useState()
  const [krasuCenaEurKgCMYK, setKrasuCenaEurKgCMYK] = useState()
  const [krasuCenaEurKgPantone, setKrasuCenaEurKgPantone] = useState()
  const [krasuCenaEurKgZeltsUnSudrabs, setKrasuCenaEurKgZeltsUnSudrabs] = useState()
  const [krasuCenaEurKgSedzosaKrasaW, setKrasuCenaEurKgSedzosaKrasaW] = useState()

  //pieregulesana t.m.
  const [pieregulesanaPiekartosana, setPieregulesanaPiekartosana] = useState()
  const [pieregulesanaCmykGatavieToni, setPieregulesanaCmykGatavieToni] = useState()
  const [pieregulesanaPantone, setPieregulesanaPantone] = useState()

  //sets the state for price loading
  const [totalLoading, setTotalLoading] = useState(false)

  // sets dynamic prices
  const [dynamicPrice, setDynamicPrice] = useState([])

  // sets dynamic fixed prices
  const [dynamicFixedPrice, setDynamicFixedPrice] = useState([])

  //seciga razosana
  const [secigaRazosana, setSecigaRazosa] = useState(1)

  //template name
  const [templateName, setTemplateName] = useState("")

  //global loading for templates
  const [globalLoading, setGlobalLoading] = useState(false)

  //state for startup calculation
  const [knifePrice, setKnifePrice] = useState(0)
  const [newKnife, setNewKnife] = useState(false)
  const [knifeShape, setKnifeShape] = useState("none")
  const [newKnifeMessage, setNewKnifeMessage] = useState("")
  const [newKnifeRadiuss, setNewKnifeRadius] = useState(0)
  const [newKnifeFile, setNewKnifeFile] = useState("")

  //checks if its a new job
  const [newJob, setNewJob] = useState(false)
  const [totalPlateCost, setTotalPlateCost] = useState(0)
  const [plateObjects, setPlateObjects] = useState({})
  //checks if plate object is empty
  const plateObjectIsEmpty = Object.keys(plateObjects).length === 0

  //hotprint data
  const [hotprintMeterPerMin, setHotprintMeterPerMin] = useState(0)
  const [hotprintCostsPerH, setHotPrintCostsPerH] = useState(0)
  const [hotprintAdjustmentTimeMin, setHotprintAdjustmentTimeMin] = useState(0)
  const [hotprintAdjustmentRunningMeters, setHotprintAdjustmentRunningMeters] = useState(0)

  //changable space data
  const [changableSpace, setChangableSpace] = useState(false)

  //admin comment
  const [adminComment, setAdminComment] = useState(null)
  //designer comment
  const [designerComment, setDesignerComment] = useState(null)

  //checks if it was sent back
  const [wasSentBack, setWasSentBack] = useState(false)
  //checks if was sent from designer
  const [wasSentFromDesigner, setWasSentFromDesigner] = useState(false)

  //link for the file which comes from location.state
  const [stateFileLink, setStateFileLink] = useState(null)

  //was calculation first executed?
  const [wasCalculatePressed, setWasCalculatePressed] = useState(true)

  //filter group data
  const [filterGroup, setFilterGroup] = useState(null)
  const [filterGroupId, setFilterGroupId] = useState(null)
  const [hasFilterGroup, setHasFilterGroup] = useState(false)

  //filter groups select
  const [allFilterGroups, setAllFilterGroups] = useState([])
  const [filterGroupsLoading, setFilterGroupsLoading] = useState(false)

  //existing price filter children
  const [existingFilterChildren, seExistingFilterChildren] = useState([])

  //TAPE INFO
  const [tapeColorCount, setTapeColorCount] = useState(0)
  const [tapeMaterial, setTapeMaterial] = useState(null)
  const [tapeWidth, setTapeWidth] = useState(0)
  const [tapePrices, setTapePrices] = useState([])
  const [tapeFile, setTapeFile] = useState(null)
  const [tapeButtonLoading, setTapeButtonLoading] = useState(false)
  const [disableTapeSave, setDisableTapeSave] = useState(false)
  const [tapeOptions, setTapeOptions] = useState([{ label: "0 rolls", value: 0 }])

  //handles aproved
  const [aproved, setAproved] = useState(true)
  const [adminReview, setAdminReview] = useState(false)

  //handles product type
  const [productType, setProductType] = useState(null)

  const handleFilterGroups = (value, options) => {
    setHasFilterGroup(options.hasFilter)
    setFilterGroupId(options.id)
    setFilterGroup(options.title)

    //finds the current children of filter group
    seExistingFilterChildren(options.existingChildren)
  }

  //##### FIXED DYNAMIC PRICE #####
  //handles updating the state for dynamic price
  const handleAmountChange = (index, event) => {
    const { name, value } = event.target
    const cleanedValue = value.replace(/\s+/g, "") // Strip spaces to get raw number
    const numberValue = parseInt(cleanedValue, 10) || 0 // Default to 0 if NaN

    const values = [...dynamicPrice]
    values[index][name] = numberValue // Store as number
    setDynamicPrice(values)
  }

  //handles adding amount
  const handleAddAmount = () => {
    setDynamicPrice([...dynamicPrice, { quantity: 0, price: 0, labelWeight: 0, m2: 0 }])
  }

  //handles removing amount
  const removeAmountFields = (index) => {
    const values = [...dynamicPrice]
    values.splice(index, 1)
    setDynamicPrice(values)
  }

  //updates all the dynamically created prices with HandleCalculate
  const updateDynamicPrices = (param) => {
    const newPrice = param.map((element) => {
      let result = handleCalculate(element.quantity)
      console.log(result)

      return {
        ...element,
        price: Number(result.cenaPar1000uzlimemEur),
        labelWeight: Number(result.tiraisSvarsKg),
        m2: Number(result.papiraPaterins),
      }
    })
    setDynamicPrice(newPrice)
  }

  //##### FIXED DYNAMIC PRICE #####
  //handles updating the state for dynamic fixed price
  // Updated to accept field name and value directly
  const handleAmountChangeFixed = (index, fieldName, value) => {
    const updatedValues = [...dynamicFixedPrice] // Clone the current state
    let number = parseFloat(value)
    updatedValues[index][fieldName] = number // Update the specific field with the new value
    setDynamicFixedPrice(updatedValues) // Set the updated state
  }

  //handles adding amount
  const handleAddAmountFixed = () => {
    setDynamicFixedPrice([...dynamicFixedPrice, { quantity: 0, price: 0, labelWeight: 0, m2: 0 }])
  }

  //handles removing amount dynamic fixed price
  const removeAmountFieldsFixed = (index) => {
    const values = [...dynamicFixedPrice]
    values.splice(index, 1)
    setDynamicFixedPrice(values)
  }

  //updates all the dynamically fixed created prices with HandleCalculate
  const updateDynamicPricesFixed = (param) => {
    const newPrice = param.map((element) => {
      let result = handleCalculate(element.quantity)
      return {
        ...element,
        labelWeight: Number(result.tiraisSvarsKg),
        m2: Number(result.papiraPaterins),
      }
    })
    setDynamicFixedPrice(newPrice)
  }

  //removes image from the current product or template
  const handleRemoveFile = async () => {
    // Check if stateFileLink is not set or if it's not a string
    if (!stateFileLink || typeof stateFileLink !== "string") {
      console.log("No valid file link available to delete.")
      // Optionally, reset fileList and stateFileLink if needed
      setFileList([])
      setStateFileLink(null)
      return
    }

    // Proceed with file deletion since stateFileLink is a string
    const fileRef = ref(storage, stateFileLink)

    deleteObject(fileRef)
      .then(async () => {
        console.log("File deleted successfully")
        setStateFileLink(null)
        setFileList([])
        message.success("Image removed successfully!")

        // Determine which document to update based on the context
        const docRef = dataFromState.comingFromTemplate
          ? doc(db, "priceTemplates", dataFromState.id)
          : doc(db, "priceCalculation", dataFromState.id)

        // Update the document in Firestore
        await updateDoc(docRef, {
          "product.productFileUrl": null,
        }).then(() => {
          console.log("product image set to null")
        })

        console.log("Document updated successfully")
      })
      .catch((error) => {
        console.error("Error removing image: ", error)
        message.error("Failed to remove image!")
      })
  }

  //checks if admin state exists and updates accordingly
  useEffect(() => {
    if ("fromAdmin" in (dataFromState || {})) {
      // property was present (even if false)
      setFromAdminState(dataFromState.fromAdmin)
    } else {
      // property was missing
      // maybe reset to a default, or leave unchanged
      setFromAdminState(false)
    }
  }, [dataFromState])

  //use Effect for calculating the machine points
  useEffect(() => {
    let result =
      cmykColors +
      pantoneColors +
      coveringWCount +
      varnishUse +
      goldOrSilver +
      selectedReliefUse +
      foilCount
    setPointsRemaining(totalPointsRemaining * howManyTimes - result)
  }, [
    cmykColors,
    pantoneColors,
    coveringWCount,
    varnishUse,
    goldOrSilver,
    selectedReliefUse,
    foilCount,
    howManyTimes,
    totalPointsRemaining,
  ])

  //resets init state
  useEffect(() => {
    setTotalPointsRemaining(machineStations)
    setPointsRemaining(machineStations)
    setCmykColors(0)
    setCmykPercent(1)
    setPantoneColors(0)
    setPantonePercent(0)
    setCoveringWCount(0)
    setCoveringWPercent(0)
    setVarnishType("none")
    setVarnishXpretp(0)
    // setVarnishCost(0);
    setVarnishPercent(1)
    setVarnishUse(0)
    setSelectedVarnish("none")
    setSelectedVarnishId(null)
    setGoldOrSilver(0)
    setGoldOrSilverPercent(0)
    setReliefMeters(0)
    setReliefRunningMeters(0)
    setReliefTimePerMin(0)
    setSelectedReliefValue(0)
    setSelectedReliefId(null)
    setFoilCount(0)
    setFoilCosts(0)
    setFoilColor("none")
    setSelectedFoilColor("none")
    setSelectedFoilId(null)
    setFoilPercent(0)
    setHowManyTimes(1)
    setSecigaRazosa(1)
    setSelectedReliefUse(0)
    setSelectedRelief("No")
  }, [selectedMachine, machineStations])

  //updates row balance on every change
  useEffect(() => {
    let balance = 0
    if (selectedMaterial !== "none") {
      balance =
        Number(formatWidth) -
        (Number(numberOfColumns) * Number(labelWidth) +
          (Number(numberOfColumns) - 1) * Number(kniveSpaceBetweenRows) +
          2 * Number(machineAlsm))
    }
    setRowBalance(balance)
  }, [
    formatWidth,
    numberOfColumns,
    labelWidth,
    kniveSpaceBetweenRows,
    machineAlsm,
    selectedMaterial,
  ])

  //TEMPLATE FETCH
  //updates data from location and puts everything where it belongs
  useEffect(() => {
    setGlobalLoading(true)
    if (dataFromState) {
      //sets machine
      if (machines) {
        const templateMachine = machines.find((data) => data.machine === dataFromState.machine)
        setSelectedMachine(templateMachine.machine)
        setMachineSpeed(templateMachine.speed)
        setMachineAlsm(templateMachine.alsm)
        setMachineElectricity(templateMachine.costs.electricity)
        setMachineWork(templateMachine.costs.worker)
        setMachineAmortization(templateMachine.costs.amortization)
        setTotalPointsRemaining(templateMachine.stations)

        //total points remaining
        let reliefUse = 0
        if (dataFromState.print.reliefId !== null) {
          reliefUse = 1
        }
        let result =
          dataFromState.print.cmykColors +
          dataFromState.print.pantoneColors +
          dataFromState.print.coveringWCount +
          dataFromState.print.varnishUse +
          dataFromState.print.goldOrSilver +
          reliefUse +
          dataFromState.print.foilCount
        setPointsRemaining(templateMachine.stations * dataFromState.advanced.howManyTimes - result)

        if (templateMachine.machine === "Arsoma") {
          setActiveKey(`2`)
        } else if (templateMachine.machine === "Viva") {
          setActiveKey(`1`)
        } else if (templateMachine.machine === "Cutter") {
          setActiveKey(`0`)
        }
      }

      //sets client
      setSelectedClient(dataFromState.client)
      setClientsProfit(dataFromState.clientsProfit)
      setSelectedClientId(dataFromState.clientId)
      setSelectedClientName(dataFromState.client)
      setClientIsLead(Boolean(dataFromState?.clientisLead || dataFromState?.lead || false))

      //sets product
      setProductName(dataFromState.product.productName)

      //label count
      setLabelCount(dataFromState.labelCount)

      //handle knife
      if (dataFromState.knifeCode) {
        const searchByCode = async (code) => {
          try {
            const response = await axiosInstance.get(
              `/api/searchByCode?code=${encodeURIComponent(code)}`,
            )
            const knifeData = response.data
            if (knifeData) {
              setKniveButtonText(knifeData.code)
              setKniveSpaceBetweenRows(knifeData.spaceBetweenRows)
              setLabelWidth(knifeData.width)
              setLabelHeight(knifeData.height)
              setSelectedKnifeCode(knifeData.code)
              setSelectedKnifeId(dataFromState.id)
              setNumberOfColumns(knifeData.rowss)
              setKniveGapRaport(knifeData.gapRaport)

              console.log(knifeData)
            }
          } catch (error) {
            console.error("Failed to fetch data:", error)
          }
        }

        searchByCode(dataFromState.knifeCode)
      }

      //handle material
      if (dataFromState.material) {
        const materialRef = doc(db, "materials", dataFromState.materialId)
        getDoc(materialRef).then((docSnap) => {
          if (docSnap.exists()) {
            let materialData = docSnap.data()
            setMaterialEurM2(materialData.eurM2)
            setMaterialGM2(materialData.gM2)
            setSelectedMaterial(materialData.material)
            setSelectedMaterialId(dataFromState.materialId)
            setFormatWidthList(materialData.widths)
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!")
          }
        })
      }

      //handle format
      setFormatWidth(dataFromState.formatWidth)

      //handle row balance
      setRowBalance(dataFromState.advanced.rowBalance)

      //handle sequential production
      setSecigaRazosa(dataFromState.advanced.sequentialProduction)

      //handle advanced
      if (dataFromState.advanced.extraProfit !== 0 || dataFromState.advanced.fixedPrice === true) {
        setVisible(true)

        //checks fixed price
        if (dataFromState.advanced.fixedPrice === true) {
          setFixedPrice(true)
          setDisableFixedPriceButton(false)
          setTotalFixedPrice(dataFromState.totalFixedPrice)
        }

        //checks extra profit
        if (dataFromState.advanced.extraProfit !== 0) {
          setExtraProfitSlider(dataFromState.advanced.extraProfit)
        }
      }

      //handles print settings
      //cmyk
      setCmykColors(dataFromState.print.cmykColors)

      //pantone
      setPantoneColors(dataFromState.print.pantoneColors)
      setPantonePercent(dataFromState.print.pantonePercent)

      //white
      setCoveringWCount(dataFromState.print.coveringWCount)
      setCoveringWPercent(dataFromState.print.coveringWPercent)
      setCmykPercent(1)

      //varnish
      if (varnish && dataFromState.print.varnishId !== null) {
        const adminVarnish = varnish.find((data) => data.id === dataFromState.print.varnishId)
        setVarnishType(adminVarnish.type)
        setVarnishXpretp(adminVarnish.xpretp)
        setVarnishUse(adminVarnish.used)
        setSelectedVarnish(adminVarnish.type)
        setSelectedVarnishId(adminVarnish.id)
        setVarnishPercent(1)
      }

      //silver or gold
      setGoldOrSilver(dataFromState.print.goldOrSilver)
      setGoldOrSilverPercent(dataFromState.print.goldOrSilverPercent)

      //relief
      if (relief && dataFromState.print.reliefId !== null) {
        const adminRelief = relief.find((data) => data.id === dataFromState.print.reliefId)
        setReliefMeters(adminRelief.meters)
        setReliefRunningMeters(adminRelief.runningMeters)
        setReliefTimePerMin(adminRelief.timePerMin)
        setSelectedReliefValue(adminRelief)
        setSelectedReliefUse(adminRelief.value)
        setSelectedRelief(adminRelief.tag)
        setSelectedReliefId(adminRelief.id)
      }

      //foil
      if (foil && dataFromState.print.foilId !== null) {
        const adminFoil = foil.find((data) => data.id === dataFromState.print.foilId)
        setFoilCosts(adminFoil.costs)
        setFoilColor(adminFoil.color)
        setSelectedFoilColor(adminFoil.color)
        setSelectedFoilId(adminFoil.id)
        setFoilPercent(dataFromState.print.foilPercent)
        setFoilCount(dataFromState.print.foilCount)
      }

      //user comments
      if (dataFromState.userComment != null) {
        setUserComment(dataFromState.userComment)
      }

      //set price
      setTotalPrice(dataFromState.price)

      //set dynamic price
      setDynamicPrice(dataFromState.dynamicPrice)

      //sets fixed dynamic price
      if (dataFromState.advanced.fixedPrice) {
        setDynamicFixedPrice(dataFromState.dynamicFixedPrice)
      }

      //set how many times
      setHowManyTimes(dataFromState.advanced.howManyTimes)

      //sets sequenciol production
      setSecigaRazosa(dataFromState.advanced.sequentialProduction)

      //sets data for a new knife
      if (dataFromState.startup?.newKnife) {
        setNewKnife(dataFromState.startup.newKnife)
        setKnifePrice(dataFromState.startup.knifePrice)
        setKniveButtonText("New Knife...")
        setKniveSpaceBetweenRows(dataFromState.startup.knifeSpaceBetweenRows ?? 3)
        setKniveGapRaport(dataFromState.startup.knifeGapRaport ?? 3)
        setLabelWidth(dataFromState.labelWidth)
        setLabelHeight(dataFromState.labelHeight)
        setSelectedKnifeCode("New Knife")
        setSelectedKnifeId("New Knife")
        setNumberOfColumns(dataFromState.numberOfColumns)
        setKnifeShape(dataFromState.startup.knifeShape)
      }

      //sets data for new job
      if (dataFromState.startup && dataFromState.startup.newJob) {
        setNewJob(dataFromState.startup.newJob)
        setTotalPlateCost(dataFromState.startup.newJob)
        setPlateObjects(dataFromState.startup.plateObjects)
      }

      setProductType(dataFromState?.productType ? dataFromState.productType : null)

      //sets changable space
      if (dataFromState.advanced.changableSpace && dataFromState.advanced.changableSpace) {
        setChangableSpace(dataFromState.advanced.changableSpace)
        setVisible(true)
      }

      //sets designer comment
      if (dataFromState.sentBack && dataFromState.sentBack === true) {
        setAdminComment(dataFromState.adminComment)
        setWasSentBack(dataFromState.sentBack)
      }

      //sets designer comment
      if (totalState.changedByDesigner && totalState.changedByDesigner === true) {
        setWasSentFromDesigner(totalState.changedByDesigner)
        setWasSentBack(totalState.changedByDesigner)
        setDesignerComment(totalState.designerComment)
      }
      //sets admin comment
      if (totalState.orderReviewFromAdmin && totalState.orderReviewFromAdmin === true) {
        setAdminComment(totalState.adminComment)
      }

      if (dataFromState.startup) {
        if (dataFromState.startup.newKnife && dataFromState.startup.newKnifeObject) {
          setNewKnifeMessage(dataFromState.startup.newKnifeObject.message)
          setNewKnifeFile(dataFromState.startup.newKnifeObject.fileLink)
          setNewKnifeRadius(dataFromState.startup.newKnifeObject.radius)
        }
      }
      //set product file link
      setStateFileLink(dataFromState.product.productFileUrl)

      setTimeout(() => {
        setGlobalLoading(false)
      }, 1500)
    } else {
      setGlobalLoading(false)
    }
  }, [dataFromState, totalState, machines, varnish, relief, foil])

  // //FETCH FILTERS
  useEffect(() => {
    if (selectedClientId) {
      setFilterGroupsLoading(true)
      const priceRef = query(
        collection(db, "priceFilters"),
        where("clientId", "==", selectedClientId),
      )
      const unsubscribe = onSnapshot(priceRef, (snapshot) => {
        let results = []
        snapshot.docs.forEach((doc) => {
          results.push({ ...doc.data(), id: doc.id })
        })
        setAllFilterGroups(results)
        setFilterGroupsLoading(false)
      })
      return () => unsubscribe()
    }
  }, [selectedClientId])

  useEffect(() => {
    //FETCHING MACHINES
    const machinesRef = collection(db, "machines")
    getDocs(machinesRef).then((snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() })
      })
      setMachines(results)
    })

    //FETCHING MATERIAL
    const materialRef = collection(db, "materials")
    const materialQuery = query(materialRef, where("stock", "==", true))
    setMaterialLoading(true)
    getDocs(materialQuery).then((snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() })
      })
      setMaterial(results)
      setMaterialLoading(false)
    })

    //FETCHING VARNISH
    const varnishRef = collection(db, "varnish")
    const varnishQuery = query(varnishRef, orderBy("costs", "asc"))
    getDocs(varnishQuery).then((snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() })
      })
      setVarnish(results)
    })
    //FETCHING RELIEF
    const reliefRef = collection(db, "relief")
    const reliefQuery = query(reliefRef, orderBy("value", "asc"))
    getDocs(reliefQuery).then((snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() })
      })
      setRelief(results)
    })
    //FETCHING FOIL
    const foilRef = collection(db, "foil")
    getDocs(foilRef).then((snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() })
      })
      setFoil(results)
    })

    //FETCHING HOTPRINT
    const hotprintRef = doc(db, "hotprint", "GDmYoXX9pwy61D8N1zDl")
    getDoc(hotprintRef).then((snapshot) => {
      const hotprintData = snapshot.data()
      setHotprintMeterPerMin(hotprintData.meterPerMinute)
      setHotPrintCostsPerH(hotprintData.printCostsPerHour)
      setHotprintAdjustmentTimeMin(hotprintData.adjustmentTime)
      setHotprintAdjustmentRunningMeters(hotprintData.adjustmentRunningMeters)
    })

    //FETCHING PRODUCTION DEFAULTS
    const porductDefaultRef2 = doc(db, "productionCosts", "GalDdGckTxeJHAEoD4nA")
    getDoc(porductDefaultRef2).then((doc) => {
      let result = doc.data()
      setSelectedProductionMachine2Id(doc.id)
      setProductionCosts2(result.costs)
      setProductionRunningMetersMin2(result.runningMetersMin)
      setProductionTimePerMinute2(result.timeperminute)
      setSelectedProductionMachine2(result.machine)
    })
    const porductDefaultRef = doc(db, "productionCosts", "ygJHdF8Z6y3uR5H567BY")
    getDoc(porductDefaultRef).then((doc) => {
      let result = doc.data()
      setSelectedProductionMachineId(doc.id)
      setProductionCosts(result.costs)
      setProductionRunningMetersMin(result.runningMetersMin)
      setProductionTimePerMinute(result.timeperminute)
      setSelectedProductionMachine(result.machine)
    })

    //FETCHING RASTRA
    const rastraRef = collection(db, "rastra")
    getDocs(rastraRef).then((snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() })
      })
      setRastra(results[0].grams)
    })
    //FETCHING KRASUPATERINS
    const colorRef = collection(db, "krasuPaterins")
    getDocs(colorRef).then((snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() })
      })
      const cmykResult = results.find((item) => item.type === "CMYK")
      setKrasuPaterinsCMYK(Number(cmykResult.consumption))
      const pantoneResult = results.find((item) => item.type === "Pantone")
      setKrasuPaterinsPantone(Number(pantoneResult.consumption))
      const varnishResult = results.find((item) => item.type === "Varnish")
      setKrasuPaterinsLaka(Number(varnishResult.consumption))
      const goldResult = results.find((item) => item.type === "Gold")
      setKrasuPaterinsZeltaKrasa(Number(goldResult.consumption))
    })
    //FETCHING KRASU CENA
    const colorPriceRef = collection(db, "colorPrices")
    getDocs(colorPriceRef).then((snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() })
      })
      const varnishPriceResult = results.find((item) => item.type === "Varnish")
      setKrasuCenaEurKgLaka(Number(varnishPriceResult.price))
      const cmykPriceResult = results.find((item) => item.type === "CMYK")
      setKrasuCenaEurKgCMYK(Number(cmykPriceResult.price))
      const pantonePriceResult = results.find((item) => item.type === "Pantone")
      setKrasuCenaEurKgPantone(Number(pantonePriceResult.price))
      const goldPriceResult = results.find((item) => item.type === "GoldAndSilver")
      setKrasuCenaEurKgZeltsUnSudrabs(Number(goldPriceResult.price))
      const coveringWPriceResult = results.find((item) => item.type === "CoverW")
      setKrasuCenaEurKgSedzosaKrasaW(Number(coveringWPriceResult.price))
    })
    //FETCHING ADJUSTMENT TM
    const adjustmentRef = collection(db, "adjustmentTM")
    getDocs(adjustmentRef).then((snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() })
      })
      const adjustingCleanResults = results.find((item) => item.type === "Adjustment Cleanup")
      setPieregulesanaPiekartosana(Number(adjustingCleanResults.time))
      const adjustmentCMYK = results.find((item) => item.type === "Adjustment CMYK")
      setPieregulesanaCmykGatavieToni(Number(adjustmentCMYK.time))
      const adjustmentPantone = results.find((item) => item.type === "Adjustment Pantone")
      setPieregulesanaPantone(Number(adjustmentPantone.time))
    })

    //FETCHING USER DOCUMENT
    //ADDING EXTRA PERCENTAGE
    const userDocRef = doc(db, "users", user.uid)
    getDoc(userDocRef).then((docSnap) => {
      if (docSnap.exists()) {
        setUserExtraPercent(docSnap.data().extraPercentage)
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!")
      }
    })
  }, [user])

  const handleMachine = (value, option, key) => {
    console.log(option)
    setSelectedMachine(option.value)
    setMachineSpeed(option.speed)
    setMachineStations(option.stations)
    setMachineAlsm(option.alsm)
    setMachineElectricity(option.electricity)
    setMachineWork(option.worker)
    setMachineAmortization(option.amortization)
    setActiveKey(option.key)
  }

  const handleClient = (value, option) => {
    setSelectedClient(value)
    setClientsProfit(option.profit)
    setSelectedClientId(option.id)
    setSelectedClientName(option.value)
    setClientIsLead(Boolean(option.lead))
  }

  const clearKnives = () => {
    setKniveSpaceBetweenRows(3)
    setKniveGapRaport(3)
    setKniveButtonText(initalKniveButtonText)
    setLabelWidth(0)
    setLabelHeight(0)
    setSelectedKnifeCode("none")
    setSelectedKnifeId("none")
    setKnifePrice(0)
    setNewKnife(false)
  }

  const handleMaterial = (value, option) => {
    setMaterialEurM2(option.eurM2)
    setMaterialGM2(option.gM2)
    setSelectedMaterial(option.value)
    setSelectedMaterialId(option.id)
    setFormatWidthList(option.widths)
    setFormatWidth(0)
  }

  const handleFormatWidth = (value, option) => {
    setFormatWidth(option.value)
  }

  const handleVarnish = (value, option) => {
    // setVarnishCost(option.costs);
    setVarnishType(value)
    setVarnishXpretp(option.xpretp)
    setVarnishUse(option.used)
    setSelectedVarnish(option.value)
    setSelectedVarnishId(option.id)
  }

  const handleRelief = (value, option) => {
    setReliefMeters(option.meters)
    setReliefRunningMeters(option.runningMeters)
    setReliefTimePerMin(option.timePerMin)
    setSelectedReliefValue(value)
    setSelectedReliefUse(option.value)
    setSelectedRelief(option.children)
    setSelectedReliefId(option.id)
  }

  const handleFoil = (value, option) => {
    setFoilCosts(option.costs)
    setFoilColor(value)
    setSelectedFoilColor(option.value)
    setSelectedFoilId(option.id)
    console.log(option.costs)
  }

  //handles the totals calculation
  //sets total weight
  //sets total price
  const handleTheTotalCalculate = (labels) => {
    var result = handleCalculate(labels)
    updateDynamicPrices(dynamicPrice)
    setTotalPrice(result.cenaPar1000uzlimemEur)
    setTotalLabeWeight(result.tiraisSvarsKg)
    updateDynamicPricesFixed(dynamicFixedPrice)
  }

  //handles label Width & Knife width
  const handleLabelWidth = (value) => {
    setLabelWidth(value)
  }

  //handles label Height & Knife height
  const handleLabelHeight = (value) => {
    setLabelHeight(value)
  }

  const handleNumberOfColumns = (value) => {
    setNumberOfColumns(value)
  }

  //handles the state of a new job
  const handleNewJob = (value) => {
    setNewJob(value)
  }

  //returns the proper layout of the machines
  const returnMachineFields = () => {
    if (
      selectedMachine === "Arsoma" ||
      selectedMachine === "Viva" ||
      selectedMachine === "Cutter"
    ) {
      return (
        <>
          <FlexoFields
            dataFromState={dataFromState}
            selectedKnifeCode={selectedKnifeCode}
            CalculationsPopup={CalculationsPopup}
            selectedMachine={selectedMachine}
            setNumberOfColumns={setNumberOfColumns}
            machineAlsm={machineAlsm}
            setKniveSpaceBetweenRows={setKniveSpaceBetweenRows}
            setKniveGapRaport={setKniveGapRaport}
            setLabelWidth={setLabelWidth}
            setLabelHeight={setLabelHeight}
            setSelectedKnifeCode={setSelectedKnifeCode}
            setSelectedKnifeId={setSelectedKnifeId}
            setKniveButtonText={setKniveButtonText}
            kniveButtonText={kniveButtonText}
            setNewKnife={setNewKnife}
            setKnifePrice={setKnifePrice}
            setKnifeShape={setKnifeShape}
            newKnifeMessage={newKnifeMessage}
            setNewKnifeMessage={setNewKnifeMessage}
            newKnifeRadiuss={newKnifeRadiuss}
            setNewKnifeRadius={setNewKnifeRadius}
            setNewKnifeFile={setNewKnifeFile}
            knifeShape={knifeShape}
            clearKnives={clearKnives}
            labelWidth={labelWidth}
            handleLabelWidth={handleLabelWidth}
            labelHeight={labelHeight}
            handleLabelHeight={handleLabelHeight}
            selectedMaterial={selectedMaterial}
            handleMaterial={handleMaterial}
            materialLoading={materialLoading}
            material={material}
            formatWidth={formatWidth}
            handleFormatWidth={handleFormatWidth}
            formatWidthList={formatWidthList}
            numberOfColumns={numberOfColumns}
            handleNumberOfColumns={handleNumberOfColumns}
            newKnife={newKnife}
            rowBalance={rowBalance}
            tooltipRowBalance={tooltipRowBalance}
            userComment={userComment}
            setUserComment={setUserComment}
            visible={visible}
            extraProfitSlider={extraProfitSlider}
            setExtraProfitSlider={setExtraProfitSlider}
            changableSpace={changableSpace}
            setChangableSpace={setChangableSpace}
            fixedPrice={fixedPrice}
            handleFixedPrice={handleFixedPrice}
            totalFixedPrice={totalFixedPrice}
            setTotalFixedPrice={setTotalFixedPrice}
            disableFixedPriceButton={disableFixedPriceButton}
            dynamicFixedPrice={dynamicFixedPrice}
            handleAmountChangeFixed={handleAmountChangeFixed}
            removeAmountFieldsFixed={removeAmountFieldsFixed}
            handleAddAmountFixed={handleAddAmountFixed}
            setVisible={setVisible}
          />
        </>
      )
    } else if (selectedMachine === "Tape") {
      return (
        <>
          <TapeLayout
            setTapeOptions={setTapeOptions}
            tapeMaterial={tapeMaterial}
            setTapeMaterial={setTapeMaterial}
            tapeWidth={tapeWidth}
            setTapeWidth={setTapeWidth}
            setTapePrices={setTapePrices}
            tapeColorCount={tapeColorCount}
          />
        </>
      )
    }
  }

  //returns correct price tabs
  const returnCorrectPriceTabs = () => {
    if (
      selectedMachine === "Arsoma" ||
      selectedMachine === "Viva" ||
      selectedMachine === "Cutter"
    ) {
      return (
        <FlexoPriceSection
          newKnife={newKnife}
          newJob={newJob}
          knifeStartupPrice={knifeStartupPrice}
          plateStartup={plateStartup}
          totalPlateCost={totalPlateCost}
          knifePrice={knifePrice}
          dynamicPrice={dynamicPrice}
          handleAmountChange={handleAmountChange}
          removeAmountFields={removeAmountFields}
          handleAddAmount={handleAddAmount}
          cmykColors={cmykColors}
          pantoneColors={pantoneColors}
          coveringWCount={coveringWCount}
          varnishUse={varnishUse}
          goldOrSilver={goldOrSilver}
          reliefRunningMeters={reliefRunningMeters}
          foilCount={foilCount}
          showFileButton={showFileButton}
          wasSentBack={wasSentBack}
          dataFromState={dataFromState}
          adminComment={adminComment}
          setAdminComment={setAdminComment}
          wasSentFromDesigner={wasSentFromDesigner}
          designerComment={designerComment}
          setDesignerComment={setDesignerComment}
          handleTheTotalCalculate={handleTheTotalCalculate}
          labelCount={labelCount}
          returnCorrectButton={returnCorrectButton}
          templateName={templateName}
          setTemplateName={setTemplateName}
          saveButtonDisabled={saveButtonDisabled}
          saveTemplate={saveTemplate}
          totalLoading={totalLoading}
          stateFileLink={stateFileLink}
          handleRemoveFile={handleRemoveFile}
          recalculate={dataFromState?.recalculation ?? false}
          template={dataFromState?.comingFromTemplate ?? false}
          fromAdminState={fromAdminState}
        />
      )
    } else if (selectedMachine === "Tape") {
      return (
        <>
          <TapePriceSection
            tapeButtonLoading={tapeButtonLoading}
            createNewTapeProduct={createNewTapeProduct}
            tapeFile={tapeFile}
            setTapeFile={setTapeFile}
            tapePrices={tapePrices}
            setTapePrices={setTapePrices}
            disableTapeSave={disableTapeSave}
            tapeWidth={tapeWidth}
            tapeOptions={tapeOptions}
          />
        </>
      )
    }
  }

  //checks for the machine and puts the right prices
  useEffect(() => {
    //checks if there is a new job
    if (newJob) {
      //prices for arsoma
      if (selectedMachine === "Arsoma") {
        let cmyk = cmykColors
        let pantone = pantoneColors
        let white = coveringWCount
        let varnish = selectedVarnish.includes("sector") ? 1 : 0
        let silverOrGold = goldOrSilver
        let relief = selectedReliefUse
        let total = cmyk + pantone + white + varnish + silverOrGold + relief
        let totalCost = total * 30
        setTotalPlateCost(totalCost)
        setPlateObjects({
          cmyk: cmykColors,
          pantone: pantoneColors,
          white: coveringWCount,
          varnish: selectedVarnish.includes("sector") ? 1 : 0,
          silverOrGold: goldOrSilver,
          relief: selectedReliefUse,
        })
      } else if (selectedMachine === "Viva") {
        let white = coveringWCount
        let varnish = selectedVarnish.includes("sector") ? 1 : 0
        let silverOrGold = goldOrSilver
        let total = white + varnish + silverOrGold
        let totalCostFlexo = total * 30
        let totalCostHotPrint = foilCount * 100
        let totalCostEmbossing = selectedReliefUse * 150
        let totalCost = totalCostFlexo + totalCostHotPrint + totalCostEmbossing
        setTotalPlateCost(totalCost)
        setPlateObjects({
          white: coveringWCount,
          varnish: selectedVarnish.includes("sector") ? 1 : 0,
          silverOrGold: goldOrSilver,
          relief: selectedReliefUse,
          foil: foilCount,
        })
      } else {
        setTotalPlateCost(0)
        setPlateObjects({})
      }
    }
  }, [
    newJob,
    cmykColors,
    selectedMachine,
    pantoneColors,
    foilCount,
    coveringWCount,
    selectedVarnish,
    goldOrSilver,
    selectedReliefUse,
  ])

  //returns knife price
  const knifeStartupPrice = () => {
    return (
      <>
        <Space>
          <Text>Knife price (eur) : </Text>
          <Text style={{ color: "#1677ff" }}>{knifePrice}</Text>
        </Space>
      </>
    )
  }

  //returns for Startup Costs
  const plateStartup = () => {
    return (
      <>
        <Space>
          <Text>Cost (eur)</Text>
          <Text style={{ color: "#1677ff" }}>{totalPlateCost}</Text>
        </Space>
        <ul>
          {plateObjectIsEmpty ? (
            <p>The object is empty.</p>
          ) : (
            Object.entries(plateObjects)
              .filter(([key, value]) => value > 0)
              .map(([key, value]) => (
                <li key={key}>
                  {key} count: {value}
                </li>
              ))
          )}
        </ul>
      </>
    )
  }

  //returns the correct button for sending further
  const returnCorrectButton = () => {
    const disableAllButtons =
      saveButtonDisabled || wasCalculatePressed || fromAdminState || !productType
    // First, check if dataFromState.recalculation exists and is truthy
    if (dataFromState && dataFromState.recalculation) {
      if (dataFromState && dataFromState.adminRequest) {
        return (
          <>
            <Popconfirm
              disabled={saveButtonDisabled || wasCalculatePressed}
              title="Are you sure to you want to save?"
              onConfirm={(e) => handleUpdatePriceFromRequest(e, true)}
              okText="Yes"
              cancelText="No">
              <Button loading={totalLoading} disabled={disableAllButtons} type="default" block>
                Update Price from Request
              </Button>
            </Popconfirm>

            <AdminCommentModal data={dataFromState} />
          </>
        )
      } else {
        return (
          <Popconfirm
            disabled={saveButtonDisabled || wasCalculatePressed}
            title="Are you sure to you want to save?"
            onConfirm={(e) => handleUpdatePrice(e, false)}
            okText="Yes"
            cancelText="No">
            <Button loading={totalLoading} disabled={disableAllButtons} type="default" block>
              Update Price
            </Button>
          </Popconfirm>
        )
      }
    }

    // Then, handle the other conditions
    if (wasSentBack && !wasSentFromDesigner) {
      return (
        <Popconfirm
          disabled={saveButtonDisabled || wasCalculatePressed || !productType}
          title="Are you sure to you want to save?"
          onConfirm={sendPriceFromSentBack}
          okText="Yes"
          cancelText="No">
          <Button
            loading={totalLoading}
            disabled={saveButtonDisabled || wasCalculatePressed || !productType}
            type="default"
            block>
            Save price & Review
          </Button>
        </Popconfirm>
      )
    } else if (wasSentFromDesigner) {
      return (
        <Popconfirm
          disabled={saveButtonDisabled || wasCalculatePressed || !productType}
          title="Are you sure to you want to save?"
          onConfirm={(e) => sendPriceWithOrder(e)}
          okText="Yes"
          cancelText="No">
          <Button
            loading={totalLoading}
            disabled={saveButtonDisabled || wasCalculatePressed || !productType}
            type="default"
            block>
            Send for review
          </Button>
        </Popconfirm>
      )
    } else {
      return (
        <Popconfirm
          disabled={saveButtonDisabled || wasCalculatePressed || !productType}
          title="Are you sure to you want to save?"
          onConfirm={(e) => handleSavePrice(e)}
          okText="Yes"
          cancelText="No">
          <Button
            loading={totalLoading}
            disabled={saveButtonDisabled || wasCalculatePressed || !productType}
            type="default"
            block>
            Save price
          </Button>
        </Popconfirm>
      )
    }
  }

  // Upload File props
  const fileProps = {
    onRemove: (file) => {
      setFileList((prevList) => prevList.filter((item) => item.uid !== file.uid))
      setProductFile(null)
      setStateFileLink(null)
    },
    beforeUpload: async (file) => {
      const isValidImageType = ["image/jpeg", "image/png"].includes(file.type)
      if (!isValidImageType) {
        message.error("You can only upload JPG/JPEG/PNG files!")
        return Upload.LIST_IGNORE // Prevent upload
      }

      // Create a temporary URL to validate image dimensions
      const img = new Image()
      img.src = URL.createObjectURL(file)
      try {
        await new Promise((resolve, reject) => {
          img.onload = () => {
            if (img.width < 300 || img.height < 300) {
              message.error("Image dimensions should be at least 300x300!")
              reject(new Error("Invalid image dimensions."))
            } else {
              resolve()
            }
          }
          img.onerror = () => {
            message.error("Error while reading the image.")
            reject(new Error("Error reading image."))
          }
        })

        // Proceed with upload if image dimensions are valid
        const storageRef = ref(storage, `product/${file.name}`)
        const uploadTask = await uploadBytes(storageRef, file)
        const downloadURL = await getDownloadURL(uploadTask.ref)

        // Update state with the new file and URL
        setFileList([{ uid: file.uid, name: file.name, status: "done", url: downloadURL }])
        setProductFile(file)
        setStateFileLink(downloadURL)
      } catch (error) {
        // Handle errors such as invalid image dimensions or upload errors
        console.error(error)
        return Upload.LIST_IGNORE // Prevent upload
      }

      return false // Prevent the Upload component from handling the upload
    },
    fileList, // Pass the fileList state to the Upload component
  }

  // Returns the proper UI for if the price was already uploaded
  const showFileButton = (value) => {
    if (value) {
      return (
        <Link target="_blank" href={stateFileLink}>
          <Space>
            <FileOutlined />
            View File
          </Space>
        </Link>
      )
    } else {
      return (
        <Upload {...fileProps} customRequest={() => {}} maxCount={1} block>
          <Button block icon={<UploadOutlined />}>
            Select File
          </Button>
        </Upload>
      )
    }
  }

  //handles filter add
  //if the filter is set to false, then nothing, else adds the filter
  const addPriceToGroup = async (id) => {
    //creates a new object
    const newObject = {
      title: productName,
      key: id,
      isLeaf: true,
    }
    //combines with the previous price filters
    const newArray = [...existingFilterChildren, newObject]

    try {
      if (hasFilterGroup) {
        updateDoc(doc(db, "priceFilters", filterGroupId), {
          children: newArray,
        })
      } else {
        return
      }
    } catch (error) {
      console.log(error.message)
      message.error(error)
    }
  }

  // Determine the value of "aproved" based on "fixedPrice"
  useEffect(() => {
    if (fixedPrice) {
      // If fixedPrice is true, always set approved to true
      console.log("approved = true")
      setAproved(false)
    } else {
      // If fixedPrice is false, then approved depends on adminReview
      setAproved(!adminReview)
      console.log("approved", !adminReview)
    }
  }, [fixedPrice, adminReview])

  //handle checkmark
  const handleAdminReview = (e) => {
    setAdminReview(e.target.checked)
  }

  //price object that contains all the values for price
  let priceObject = {
    price: totalPrice,
    clientisLead: Boolean(clientisLead),
    clientId: selectedClientId,
    client: selectedClientName,
    clientsProfit: clientsProfit,
    knifeCode: selectedKnifeCode,
    knifeId: selectedKnifeId,
    print: {
      cmykColors: cmykColors,
      cmykPercent: cmykPercent,
      pantoneColors: pantoneColors,
      pantonePercent: pantonePercent,
      coveringWCount: coveringWCount,
      coveringWPercent: coveringWPercent,
      varnishType: selectedVarnish,
      varnishPercent: varnishPercent,
      varnishUse: varnishUse,
      varnishId: selectedVarnishId,
      goldOrSilver: goldOrSilver,
      goldOrSilverPercent: goldOrSilverPercent,
      relief: selectedRelief,
      reliefId: selectedReliefId,
      foilCount: foilCount,
      foilColor: selectedFoilColor,
      foilPercent: foilPercent,
      foilId: selectedFoilId,
    },
    labelCount: labelCount,
    labelWeight: labelWeight,
    labelWidth: labelWidth,
    labelHeight: labelHeight,
    material: selectedMaterial,
    materialId: selectedMaterialId,
    formatWidth: formatWidth,
    numberOfColumns: numberOfColumns,
    timestamp: serverTimestamp(),
    date: {
      status: 0,
      lastEdit: serverTimestamp(),
      created: serverTimestamp(),
    },
    filterGroup: filterGroup,
    filterGroupId: filterGroupId,
    hasFilterGroup: hasFilterGroup,
    user: user.uid,
    userEmail: user.email,
    machine: selectedMachine,
    machineCosts: {
      worker: machineWorker,
      amortization: machineAmortization,
      electricity: machineElectricity,
    },
    product: {
      productName: productName,
      productFileUrl: stateFileLink,
    },
    aproved: aproved,
    changed: false,
    advanced: {
      sequentialProduction: secigaRazosana,
      howManyTimes: howManyTimes,
      extraProfit: extraProfitSlider,
      productionMachine: selectedProductionMachine,
      productionMachineId: selectedProductionMachineId,
      productionMachine2: selectedProductionMachine2,
      productionMachine2Id: selectedProductionMachine2Id,
      rowBalance: rowBalance,
      fixedPrice: fixedPrice,
      rastra: rastra,
      changableSpace: changableSpace,
    },
    userComment: userComment,
    dynamicPrice: dynamicPrice,
    dynamicFixedPrice: dynamicFixedPrice,
    totalFixedPrice: totalFixedPrice,
    productType: productType,
    startup: {
      newKnife: newKnife,
      knifePrice: knifePrice,
      newJob: newJob,
      plateObjects: plateObjects,
      knifeShape: knifeShape,
      newKnifeObject: newKnife
        ? {
            width: labelWidth,
            height: labelHeight,
            radius: newKnifeRadiuss,
            client: selectedClientName,
            clientId: selectedClientId,
            message: newKnifeMessage,
            shape: knifeShape,
            knifePrice: knifePrice,
            product: productName,
            user: user.email,
            machine: selectedMachine,
            fileLink: newKnifeFile,
            rows: numberOfColumns,
          }
        : {},
    },
    sentBack: false,
  }

  //checks if savebutton should be disabled
  useEffect(() => {
    if (
      tapeColorCount === 0 ||
      tapeMaterial === null ||
      selectedClientId === 0 ||
      productName === null ||
      tapeFile === null ||
      !productType
    ) {
      setDisableTapeSave(true)
    } else {
      setDisableTapeSave(false)
    }
  }, [tapeColorCount, tapeMaterial, selectedClientId, productName, tapeFile, productType])

  //handle save tape price
  const createNewTapeProduct = async () => {
    setTapeButtonLoading(true)
    const collectionRef = collection(db, "tapePrices")

    try {
      const file = tapeFile

      if (!file) {
        message.error("Please select a file to upload.")
        setTapeButtonLoading(false)
        return // Exit if no file is selected
      }

      // Step 1: Upload the file and get the download URL first
      const docRef = doc(collectionRef) // Create a reference to a new document, but don't create it yet
      const filePath = `tape/${docRef.id}/${file.name}`
      const storageRef = ref(storage, filePath)
      await uploadBytesResumable(storageRef, file)
      const downloadURL = await getDownloadURL(ref(storage, filePath))

      // Step 2: Create the document with the initial data and the download URL
      await setDoc(docRef, {
        clientId: selectedClientId,
        client: selectedClientName,
        clientisLead: Boolean(clientisLead),
        clientsProfit: clientsProfit,
        created: serverTimestamp(),
        updated: serverTimestamp(),
        prices: tapePrices,
        filterGroup: filterGroup,
        filterGroupId: filterGroupId,
        hasFilterGroup: hasFilterGroup,
        tapeColorCount: tapeColorCount,
        material: tapeMaterial.material,
        materialId: tapeMaterial.id,
        tapeMaterial: tapeMaterial,
        tapeWidth: tapeWidth,
        formatWidth: 150,
        productType: productType,
        user: user.uid,
        userEmail: user.email,
        machine: selectedMachine,
        machineCosts: {
          worker: machineWorker,
          amortization: machineAmortization,
          electricity: machineElectricity,
        },
        product: {
          productName: productName,
          productFileUrl: downloadURL,
        },
        aproved: aproved,
        changed: false,
        tapePrice: true,
        sentBack: false,
      })

      message.success("Product created")
    } catch (error) {
      console.error("Error:", error)
      message.error(error.message)
    } finally {
      setTapeButtonLoading(false)
      navigate("/tape-prices")
    }
  }

  //sends price back from order sent back
  const sendPriceWithOrder = async (e) => {
    e.preventDefault()

    setTotalLoading(true)
    //refference for databse Price calculation
    const priceref = doc(db, "orders", totalState.id)
    try {
      updateDoc(priceref, {
        selectedProduct: priceObject,
        updated: serverTimestamp(),
        orderForAdmin: true,
      })
        .then(() => {
          Notification(
            "success",
            "Order sent for review",
            "You have successfully sent the order for admin review",
          )
          setTotalLoading(false)
        })
        .then(() => {
          navigate("/orders/all-orders")
        })
    } catch (err) {
      Notification("error", "Creation Error", err.message)
      setTotalLoading(false)
      console.log(err.message)
    }
  }

  //sends price back from sent back
  const sendPriceFromSentBack = async (e) => {
    e.preventDefault()
    setTotalLoading(true)

    try {
      const priceRef = doc(db, "priceCalculation", dataFromState.id)
      const originalDocSnap = await getDoc(priceRef)

      if (!originalDocSnap.exists()) {
        throw new Error("Original document not found.")
      }

      const batch = writeBatch(db)

      // Stage 1: Archive
      const historyData = {
        ...originalDocSnap.data(),
        originalPriceId: dataFromState.id,
        archivedAt: serverTimestamp(),
        archivedBy: { uid: user.uid, email: user.email },
      }
      const historyDocRef = doc(collection(db, "priceCalculationHistory"))
      batch.set(historyDocRef, historyData)

      // Stage 2: Update original document
      batch.update(priceRef, priceObject)

      // Commit both writes
      await batch.commit()

      Notification(
        "success",
        "Price Updated",
        "The price was successfully updated and its previous version was archived.",
      )
      navigate("/unapproved-prices")
    } catch (err) {
      console.error("Update process from sent-back failed:", err)
      message.error(`Update failed: ${err.message}`)
    } finally {
      setTotalLoading(false)
    }
  }

  const saveTemplate = async (e) => {
    e.preventDefault()

    setTotalLoading(true)
    // Reference for the database Price calculation
    const templateRef = collection(db, "priceTemplates")

    let downloadLink = null // Initialize downloadLink as null
    let newPriceObject = { ...priceObject } // Create a shallow copy

    try {
      // Check if the stateFileLink is not null
      if (stateFileLink) {
        // Saving files under the /templates/ folder with the filename as its name
        const fileRef = ref(storage, "templates/" + stateFileLink.name)

        // Upload the file to Firebase Storage
        await uploadBytes(fileRef, stateFileLink)

        // Get the download URL after uploading
        downloadLink = await getDownloadURL(fileRef)
      }

      // Set the productFileUrl based on downloadLink's value (null or the actual link)
      newPriceObject.product = {
        ...newPriceObject.product,
        productFileUrl: downloadLink,
      }

      // Now, add the document to Firestore
      const docRef = await addDoc(templateRef, {
        ...newPriceObject,
        templateName: templateName,
      })

      const newDocumentId = docRef.id
      await addPriceToGroup(newDocumentId)
      console.log("step 4")

      Notification("success", "Template Saved", "Price saved under Templates")
    } catch (err) {
      Notification("error", "Creation Error", err.message)
      console.log(err.message)
    } finally {
      setTotalLoading(false)
    }
    console.log(stateFileLink)
  }

  //handles the price update
  const handleUpdatePrice = async (e) => {
    e.preventDefault()
    setTotalLoading(true)

    try {
      // --- ATOMIC BATCH WRITE ---
      // Get a reference to the original document that we are updating
      const priceRef = doc(db, "priceCalculation", dataFromState.id)

      // 1. Fetch the current state of the document *before* the batch
      const originalDocSnap = await getDoc(priceRef)

      if (!originalDocSnap.exists()) {
        // This is a safeguard in case the document was deleted elsewhere
        throw new Error("Cannot update price because the original document was not found.")
      }

      // 2. Initialize a write batch
      const batch = writeBatch(db)

      // 3. Prepare and stage the HISTORY write
      const historyData = {
        ...originalDocSnap.data(), // Use the data we just fetched
        originalPriceId: dataFromState.id,
        archivedAt: serverTimestamp(),
        archivedBy: { uid: user.uid, email: user.email },
      }
      // Create a reference for the NEW document in the history collection
      const historyDocRef = doc(collection(db, "priceCalculationHistory"))
      batch.set(historyDocRef, historyData) // Use batch.set for new docs

      // 4. Stage the UPDATE to the original document
      // The priceRef is the same one we used for getDoc
      batch.update(priceRef, priceObject)

      // 5. Commit both operations at once.
      // This is the atomic step. Either both writes succeed, or none do.
      await batch.commit()

      Notification(
        "success",
        "Price Updated",
        "The price was successfully updated and its previous version was archived.",
      )
      navigate("/")
    } catch (err) {
      console.error("Atomic update failed:", err)
      message.error(`Update failed: ${err.message}`)
    } finally {
      setTotalLoading(false)
    }
  }

  //handles the price update
  const handleUpdatePriceFromRequest = async (e) => {
    e.preventDefault()
    setTotalLoading(true)

    const newAdminRequest = {
      /* ... your admin request object ... */
    }

    try {
      const priceRef = doc(db, "priceCalculation", dataFromState.id)
      const originalDocSnap = await getDoc(priceRef)

      if (!originalDocSnap.exists()) {
        throw new Error("Original document not found.")
      }

      const batch = writeBatch(db)

      // Stage 1: Archive
      const historyData = {
        ...originalDocSnap.data(),
        originalPriceId: dataFromState.id,
        archivedAt: serverTimestamp(),
        archivedBy: { uid: user.uid, email: user.email },
      }
      const historyDocRef = doc(collection(db, "priceCalculationHistory"))
      batch.set(historyDocRef, historyData)

      // Stage 2: Update original document
      batch.update(priceRef, {
        ...priceObject,
        adminRequestStatus: 2,
        adminRequests: arrayUnion(newAdminRequest),
      })

      // Commit both writes
      await batch.commit()

      Notification(
        "success",
        "Price Updated",
        "The price was successfully updated from the request and its previous version was archived.",
      )
      navigate("/")
    } catch (err) {
      console.error("Update process from request failed:", err)
      message.error(`Update from request failed: ${err.message}`)
    } finally {
      setTotalLoading(false)
    }
  }

  //handles the price saving
  const handleSavePrice = async (e) => {
    e.preventDefault()

    setTotalLoading(true)

    // Reference for database Price calculation
    const priceref = collection(db, "priceCalculation")

    // Evaluates if everything together is bigger than 0
    if (
      cmykColors +
        pantoneColors +
        coveringWCount +
        varnishUse +
        goldOrSilver +
        reliefRunningMeters +
        foilCount >
      0
    ) {
      if (!stateFileLink) {
        setTotalLoading(false)
        return Notification(
          "warning",
          "Upload File",
          "If you use print machine settings, please upload a Product file!",
        )
      }
    }

    try {
      const docRef = await addDoc(priceref, priceObject)
      const newDocumentId = docRef.id
      await addPriceToGroup(newDocumentId)
      Notification("success", "Price Saved", "You have successfully saved the price")
      setTotalLoading(false)
      navigate("/unapproved-prices")
    } catch (err) {
      Notification("error", "Creation Error", err.message)
      setTotalLoading(false)
      console.log(err.message)
    }
  }

  // Declare variables
  // pirma rinda tabula
  let cenaMaterialamKopaEurM2 = 0

  // let secigaRazosana = 1;

  // otra rinda tabula
  //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  //agrāk bija lietots, bet vairāk netiek lietots
  // let rinduSkaits = 1
  // let skIzklajuma = 0

  //tresa rinda
  let krasuSk = 0
  let krasasPaterinsGM2 = 0
  let vidCenaKrasaiEurKg = 0

  let pieregulesanasLaiksMin = 0
  let pieregulesanasTM = 0
  let razosanasLaiksMin = 0

  let tirieTekosieMetri = 0
  let tirieM2 = 0
  let tehnologiskieZudumiM2 = 0

  let materialaIzmaksasEur = 0
  let visparejasIzmaksas = 0
  let VC = 0
  let elektriba = 0
  let krasasPaterinsEur = 0

  // Pieregulesanas laiks sadalijuma pa krasam min.
  let laiksMinCMYK = 10
  let laiksMinPantone = 11
  let pecapstrade1PieregulesanaM2 = 0

  //Pecapstrade 1, 2 un 3;
  let pecapstrade1VisparejasIzmaksas = 0
  let pecapstrade1RazosanasLaiksMin = 0
  let pecapstradeElektribaEur = 0

  // Produkcijas Komplektesana
  let produkcijasKomplektesanaElektribaEur = 0
  let produkcijasKomplektesanaVisparejasIzmaksas = 0
  let produkcijasKomplektesanaRazosanasLaiks = 0

  let produkcijasKomplektesana2ElektribaEur = 0
  let produkcijasKomplektesana2VisparejasIzmaksas = 0
  let produkcijasKomplektesana2RazosanasLaiks = 0

  let productionMaterialCosts = 0

  // transports
  let transportsCena = 0
  let transports = 0
  let tiraisSvarsKg = 0

  let pardosanasSummaEur = 0
  let kopejasIzmaksas = 0

  // main settings default
  let razosanasIzmaksas = 0
  let cenaPar1000uzlimemEur = 0

  //hotfoil or hotprint
  let hotprintProductionTimePerMin = 0
  let hotprintTotalCosts = 0
  let hotprintElectricity = 0
  let hotprintMaterialCosts = 0
  let hotprintAdjustmentM2 = 0
  let hotprintCost = 0

  const handleCalculate = (totalCount) => {
    /* cenaMaterialamKopaEurM2 = IF (folijasUznesumam1Settings= 1 ){
                                        materialEurM2 * folijasUznesumam1
                                } else {
                                      meterialaCena1
                                }
                                */

    cenaMaterialamKopaEurM2 = materialEurM2

    //Formata augstums = uzlimes augstums + gap raport ( no naža)
    let formataAugstums = Number(labelHeight) + Number(kniveGapRaport)

    // tirieM2 = formataAugstums * formatWidth /1000000 * etiketesDaudzums / Sk. Izklajuma
    tirieM2 = (((formataAugstums * formatWidth) / 1000000) * totalCount) / numberOfColumns

    console.log(formatWidth)
    // Tīrie tekošie metri = tīrieM2 / Formāta platums * 1000
    tirieTekosieMetri = (tirieM2 / formatWidth) * 1000

    /* 
                                      if (document.getElementById("iespiedmasina1").value === 0) {
                                      pieregulesanasTM = 0;
                                } else {
                                      pieregulesanasTM =
                                        pieregulesanaPiekartosana +
                                        pieregulesanaCmykGatavieToni *
                                          cmykKrasuSkaits +
                                        pantoneSkaits *
                                          pieregulesanaPantone +
                                        sedzosoKrasuWSkaits *
                                          pieregulesanaPantone +
                                        zeltaVaiSudrabaKrasasSkaits *
                                          pieregulesanaPantone +
                                        (tirieTekosieMetri > 2000
                                          ? tirieTekosieMetri * 0.05
                                          : tirieTekosieMetri * 0.1) +
                                        (howManyTimes - 1) * 80 +
                                        (secigaRazosana - 1) * 60;
                                }
                                */
    if (machines === null) {
      pieregulesanasTM = 0
    } else {
      pieregulesanasTM =
        pieregulesanaPiekartosana +
        pieregulesanaCmykGatavieToni * cmykColors +
        pantoneColors * pieregulesanaPantone +
        coveringWCount * pieregulesanaPantone +
        goldOrSilver * pieregulesanaPantone +
        (tirieTekosieMetri > 2000 ? tirieTekosieMetri * 0.05 : tirieTekosieMetri * 0.1) +
        (howManyTimes - 1) * 80 +
        (secigaRazosana - 1) * 350
    }

    // tehnologiskieZudumiM2 = pieregulesanasTekosieMetri * formatWidth / 1000
    tehnologiskieZudumiM2 = (pieregulesanasTM * formatWidth) / 1000

    /*
                                Krāsas patēriņš g/m2 =
                                "cmykKrasuSkaits" * "krasuPaterinsCMYK" * "cmykParklajums%" + "pantoneParklajums%" *
                                IF("Pantone Skaits"= 0 tad 0 else 1) * "krasuPaterinsPantone" + 
                                IF("Laku Skaits" = 0 tad 0 else "lakasPārklājums%" * "meklē "Laku skaits" tabulā Laku veidi no "x pret parasto laku""
                                + "zeltaParklājums%" * "zeltaVaiSudrabaKrasasSk" * "krasuPaterinsZeltaKrasa" + "iespiedmasina2SietaParklajums%" * "iespiedmasina2Siets" * "krasuPaterinsSiets" 
                                + "iespiedmasina3SietaParklajums%" * "iespiedmasina3Siets" * "krasuPaterinsSiets" +
                                IF("sedzosoKrasuWSkaits"=0 tad 0 else "sedzošāKrāsaW%" * "sedzosoKrasuWSkaits" * Meklē "W izmantotā rasta lineatūra" iekš tabulas (sedzošās krāsas Wizmantotā vrastra veltņi))
                                */

    krasasPaterinsGM2 =
      //cmyk1
      cmykColors * krasuPaterinsCMYK * cmykPercent +
      // //cmyk2
      // Number(document.getElementById("cmykKrasuSkaits2").value) *
      //   krasuPaterinsCMYK *
      //   Number(document.getElementById("cmykParklajumsProcentos2").value) +
      // //cmyk3
      // Number(document.getElementById("cmykKrasuSkaits3").value) *
      //   krasuPaterinsCMYK *
      //   Number(document.getElementById("cmykParklajumsProcentos3").value) +
      //pantone1
      pantonePercent * (pantoneColors === 0 ? 0 : 1) * krasuPaterinsPantone +
      // extra line ar iekavam (pantonePercent * (pantoneColors === 0 ? 0 : 1) * krasuPaterinsPantone +
      //   //pantone 2
      //   Number(document.getElementById("pantoneParklajumsProcentos2").value) *
      //     (Number(document.getElementById("pantoneSkaits2").value) === 0 ? 0 : 1) *
      //     krasuPaterinsPantone +
      //   //pantone 3
      //   Number(document.getElementById("pantoneParklajumsProcentos3").value) *
      //     (Number(document.getElementById("pantoneSkaits3").value) === 0 ? 0 : 1) *
      //     krasuPaterinsPantone) +
      (varnishXpretp === 0 ? 0 : varnishPercent * varnishXpretp * krasuPaterinsLaka) +
      //zelta1
      goldOrSilverPercent * goldOrSilver * krasuPaterinsZeltaKrasa +
      // ar extra iekavinam(goldOrSilverPercent *
      //   goldOrSilver *
      //   krasuPaterinsZeltaKrasa +
      //   //zelta2
      //   Number(document.getElementById("zeltaParklajumsProcentos2").value) *
      //     Number(document.getElementById("zeltaVaiSudrabaKrasasSkaits2").value) *
      //     krasuPaterinsZeltaKrasa +
      //   //zelta3
      //   Number(document.getElementById("zeltaParklajumsProcentos3").value) *
      //     Number(document.getElementById("zeltaVaiSudrabaKrasasSkaits3").value) *
      //     krasuPaterinsZeltaKrasa) +
      (coveringWCount === 0 ? 0 : coveringWPercent * coveringWCount) *
        // + Number(document.getElementById("sedzosoKrasuWSkaitsProcentos2").value) *
        //   Number(document.getElementById("sedzosoKrasuWSkaits2").value) +
        // Number(document.getElementById("sedzosoKrasuWSkaitsProcentos3").value) *
        //   Number(document.getElementById("sedzosoKrasuWSkaits3").value)
        rastra
    krasasPaterinsGM2 = krasasPaterinsGM2.toFixed(2)
    krasasPaterinsGM2 = Number(krasasPaterinsGM2)

    /*
                                    1000 / krasasPaterinsGM2 
                                    * (cmykParklajumsProcentos * cmykKrasuSkaits * krasuPaterinsCMYK * krasuCenaEurKgCMYK
                                        + pantoneParklajumsProcentos * if(pantoneSkaits) * krasuPaterinsPantone * krasuCenaEurKgPantone
                                    + if(lakuSkaits, 0 else lakasParklajumsProcentos * lakuSkaitsVLOOKUP * krasuPaterinsLaka * krasuCenaEurKgLaka )
                                    + zeltaParklajumsProcentos * zeltaVaiSudrabaKrasasSk * krasuPaterinsZeltaKrasa * krasuCenaEurKgZeltsUnSudrabs
                                    + iespiedmasina2SietaParklajumsProcentos * iespiedmasina2Siets * krasuPaterinsSiets * krasuCenaEurKgSietaKrasaCena
                                    + iespiedmasina23ietaParklajumsProcentos * iespiedmasina3Siets * krasuPaterinsSiets * krasuCenaEurKgSietaKrasaCena
                                    + if(sedzosoKrasuWSkaits = 0 tad 0 else sedzosaKrasaWProcentos * krasuCenaEurKgSedzosaKrasaW * sedzosoKrasuWSkaits * "meklē wIzmantotaRastraLiantūru iekš Sedzoso Krasu W izmantoto" ) /1000
                            
                                  */

    vidCenaKrasaiEurKg =
      ((1000 / krasasPaterinsGM2) *
        //cmyk1
        (cmykPercent * cmykColors * krasuPaterinsCMYK * krasuCenaEurKgCMYK +
          // //cmyk2
          // Number(document.getElementById("cmykParklajumsProcentos2").value) *
          //   Number(document.getElementById("cmykKrasuSkaits2").value) *
          //   krasuPaterinsCMYK *
          //   krasuCenaEurKgCMYK +
          // //cmyk3
          // Number(document.getElementById("cmykParklajumsProcentos3").value) *
          //   Number(document.getElementById("cmykKrasuSkaits3").value) *
          //   krasuPaterinsCMYK *
          //   krasuCenaEurKgCMYK +
          //pantone 1
          pantonePercent *
            (pantoneColors === 0 ? 0 : 1) *
            krasuPaterinsPantone *
            krasuCenaEurKgPantone +
          // //pantone 2
          // Number(document.getElementById("pantoneParklajumsProcentos2").value) *
          //   (Number(document.getElementById("pantoneSkaits2").value) === 0 ? 0 : 1) *
          //   krasuPaterinsPantone *
          //   krasuCenaEurKgPantone +
          // //pantone 3
          // Number(document.getElementById("pantoneParklajumsProcentos3").value) *
          //   (Number(document.getElementById("pantoneSkaits3").value) === 0 ? 0 : 1) *
          //   krasuPaterinsPantone *
          //   krasuCenaEurKgPantone) +
          (varnishUse === 0
            ? 0
            : varnishPercent * varnishXpretp * krasuPaterinsLaka * krasuCenaEurKgLaka) +
          //zelta1
          goldOrSilverPercent *
            goldOrSilver *
            krasuPaterinsZeltaKrasa *
            krasuCenaEurKgZeltsUnSudrabs +
          // //zelta2
          // Number(document.getElementById("zeltaParklajumsProcentos2").value) *
          //   Number(document.getElementById("zeltaVaiSudrabaKrasasSkaits2").value) *
          //   krasuPaterinsZeltaKrasa *
          //   krasuCenaEurKgZeltsUnSudrabs +
          // //zelta3
          // Number(document.getElementById("zeltaParklajumsProcentos3").value) *
          //   Number(document.getElementById("zeltaVaiSudrabaKrasasSkaits3").value) *
          //   krasuPaterinsZeltaKrasa *
          //   krasuCenaEurKgZeltsUnSudrabs
          (coveringWCount === 0 ? 0 : coveringWPercent * krasuCenaEurKgSedzosaKrasaW) *
            // +
            //   Number(document.getElementById("sedzosoKrasuWSkaitsProcentos2").value) *
            //     krasuCenaEurKgSedzosaKrasaW +
            //   Number(document.getElementById("sedzosoKrasuWSkaitsProcentos3").value) *
            //     krasuCenaEurKgSedzosaKrasaW
            coveringWCount *
            rastra)) /
      1000
    vidCenaKrasaiEurKg = vidCenaKrasaiEurKg.toFixed(2)
    vidCenaKrasaiEurKg = Number(vidCenaKrasaiEurKg)

    // krasasPaterinsEur = if (krasas paterins g/m2 = 0) tad 0 ; else = (tirieM2 + tehnologiskieZudumiM2 * 0.5) * krasas paterins g/m2 / 1000 * Vide.cena krasai EUR/kg
    if (krasasPaterinsGM2 === 0) {
      krasasPaterinsEur = 0
    } else {
      krasasPaterinsEur =
        (((tirieM2 + tehnologiskieZudumiM2 * 0.5) * krasasPaterinsGM2) / 1000) * vidCenaKrasaiEurKg
    }
    krasasPaterinsEur = krasasPaterinsEur.toFixed(2)
    krasasPaterinsEur = Number(krasasPaterinsEur)

    /* Krāsu skaits = 
                                CMYK Krāsu skaits 
                                + Pantone Skaits 
                                + Zelta vai sudraba krāsu skaits
                                + iespiedmasina2Siets
                                + iespiedmasina3Siets
                                + Sedzošo Krāsu W skaits 
                                */
    krasuSk = cmykColors + pantoneColors + goldOrSilver + coveringWCount

    // Ražošanas laiks min = if(iespiedmasina1 = 0, tad 0 else{ Tīrie tekošie metri / Darba ātrums m/ min} )
    if (machines === null) {
      razosanasLaiksMin = 0
    } else {
      razosanasLaiksMin = tirieTekosieMetri / machineSpeed
      razosanasLaiksMin = razosanasLaiksMin.toFixed(2)
      razosanasLaiksMin = Number(razosanasLaiksMin)
    }

    /* pieregulēšanas laiks minūtē = if ( iespiedmasina1 = -, tad 0) else {
                                      CMYK krāsu skaits * pieregulēšanas laiks sadalajījumā a krāsām min - CMYK
                                      + Pantone skaits * pieregulēšanas laiks sadalajījumā a krāsām min - Pantone
                                      + Sedzošo krāsu W skaits * pieregulēšanas laiks sadalajījumā a krāsām min - Pantone
                                      + Zelta vai sudraba krāsu skaits * pieregulēšanas laiks sadalajījumā a krāsām min - CMYK
                                      + 20
                                      - if( Krāsu skaits > 6, tad { 
                                        (Krāsu skaits - 6) * 20 * 0.4
                                  } else {
                                        0
                                    })
                                  + (Dalita razosana, cik reizes darbs iet caur masinu - 1) * 60
                                  + (Secīgā ražošana(darbus skaits) - 1)
                                  * ((CMYK krāsu skaits * pieregulēšanas laiks sadalajījumā a krāsām min - CMYK
                                      + Pantone skaits * pieregulēšanas laiks sadalajījumā a krāsām min - Pantone
                                      + Sedzošo krāsu W skaits * pieregulēšanas laiks sadalajījumā a krāsām min - Pantone
                                      + Zelta vai sudraba krāsu skaits * pieregulēšanas laiks sadalajījumā a krāsām min - CMYK) * 0.6
                                  - if(Krāsu skaits > 6,  tad { 
                                        (Krāsu skaits - 6) * 20 * 0.4
                                   }else {
                                         0
                                   })
                              )
                            }
                                */
    if (machines === null) {
      pieregulesanasLaiksMin = 0
    } else {
      pieregulesanasLaiksMin = Math.round(
        cmykColors * laiksMinCMYK +
          pantoneColors * laiksMinPantone +
          coveringWCount * laiksMinPantone +
          goldOrSilver * laiksMinCMYK +
          20 -
          (krasuSk > 6 ? (krasuSk - 6) * 20 * 0.4 : 0) +
          (howManyTimes - 1) * 60 +
          (secigaRazosana - 1) *
            ((cmykColors * laiksMinCMYK +
              pantoneColors * laiksMinPantone +
              coveringWCount * laiksMinPantone +
              goldOrSilver * laiksMinCMYK) *
              0.6 -
              (krasuSk > 6 ? (krasuSk - 6) * 20 * 0.4 : 0)),
      )
    }

    // pecapstrade1PieregulesanaM2 = (mekle no tabulas pieregulesanas laiks sadalijuma pa krasam pier.t.m.) * Formata platums / 1000
    pecapstrade1PieregulesanaM2 = (reliefRunningMeters * formatWidth) / 1000

    // custom calculation for relief
    if (selectedReliefUse === 1) {
      productionMaterialCosts = materialEurM2 * (pecapstrade1PieregulesanaM2 + tirieM2)
    } else {
      productionMaterialCosts = 0
    }

    // pecapstrade1RazosanasLaiksMin = if (procesi = 0) tad 0 ; else ; tirieTekosieMetri / pecapstade1TekosieMetriMinute
    if (reliefRunningMeters === 0) {
      pecapstrade1RazosanasLaiksMin = 0
    } else {
      pecapstrade1RazosanasLaiksMin = tirieTekosieMetri / reliefMeters
    }

    //  Produkcijas komplektēšanas 2 ražošanas laiks = if (meklē dropdown un ir 0), tad = 0 ; else Tīrie tekošiem metri / (dropdown izvēlētais value (t.m./min.))
    produkcijasKomplektesana2RazosanasLaiks = tirieTekosieMetri / productionRunningMetersMin2

    // Produkcijas komplektēšanas ražošanas laiks = if (meklē dropdown un ir 0), tad = 0 ; else Tīrie tekošiem metri / (dropdown izvēlētais value (t.m./min.))
    produkcijasKomplektesanaRazosanasLaiks = tirieTekosieMetri / productionRunningMetersMin

    //elektriba = (pieregulesanas laiks min. + razosanas laiks min.) / 60 * 15 * 0.34
    elektriba = ((pieregulesanasLaiksMin + razosanasLaiksMin) / 60) * 15 * 0.34
    elektriba = elektriba.toFixed(2)
    elektriba = Number(elektriba)

    //visparejasIzmaksas = (mekle iespiedmasinu 1 un tas visp. izmaksas) * (pieregulesanas Laiks Min  + razosanasLaiksMin.) / 60
    visparejasIzmaksas =
      ((machineElectricity + machineWorker + machineAmortization) *
        (pieregulesanasLaiksMin + razosanasLaiksMin)) /
      60
    visparejasIzmaksas = visparejasIzmaksas.toFixed(2)
    visparejasIzmaksas = Number(visparejasIzmaksas)

    // materialaIzmaksasEur = (tirieM2  + tehnologiskieZudumiM2 ) * cenaMaterialamKopaEurM2 + krasasPaterinsEur
    materialaIzmaksasEur =
      (tirieM2 + tehnologiskieZudumiM2) * cenaMaterialamKopaEurM2 + krasasPaterinsEur
    materialaIzmaksasEur = materialaIzmaksasEur.toFixed(2)
    materialaIzmaksasEur = Number(materialaIzmaksasEur)

    // VC = (MaterialaIzmaksasEur +  VisparejasIzmaksas) * (1 + Razosanas rentabilitate) * 0,07
    VC = (materialaIzmaksasEur + visparejasIzmaksas) * (1 + Number(clientsProfit / 100)) * 0.07
    VC = VC.toFixed(2)
    VC = Number(VC)

    // updates tirais svars from input field
    tiraisSvarsKg = ((132 + krasasPaterinsGM2 * 0.3) / 1000) * tirieM2

    tiraisSvarsKg = Number(tiraisSvarsKg.toFixed(2))

    console.log("svars :", tiraisSvarsKg)

    //transports = (Mekle uz kurieni un pievieno cenu) * tiraisSvarsKg
    transports = transportsCena * tiraisSvarsKg

    // produkcijasKomplektesanaElektribaEur = (Pieregulesanas Laiks min) /60 * 15 * 0.12
    produkcijasKomplektesana2ElektribaEur = (productionTimePerMinute2 / 60) * 15 * 0.12

    // produkcijasKomplektesanaElektribaEur = (Pieregulesanas Laiks min) /60 * 15 * 0.12
    produkcijasKomplektesanaElektribaEur = (productionTimePerMinute / 60) * 15 * 0.12

    // produkcijasKomplektesana2VisparejasIzmaksas = (mekle no materialu lapas cenas EUR m2) * (produkcijas komplektesanas 2 Pieregulesana Min + produkcijas komplektesanas 2 Razosanas Laiks) /60
    produkcijasKomplektesana2VisparejasIzmaksas =
      (productionCosts2 * (productionTimePerMinute2 + produkcijasKomplektesana2RazosanasLaiks)) / 60

    // produkcijasKomplektesanaVisparejasIzmaksas = (mekle no materialu lapas cenas EUR m2) * (produkcijas komplektesanas Pieregulesana Min + produkcijas komplektesanas Razosanas Laiks) /60
    produkcijasKomplektesanaVisparejasIzmaksas =
      (productionCosts * (productionTimePerMinute + produkcijasKomplektesanaRazosanasLaiks)) / 60

    // pecapstradeElektribaEur = pieregulesanas laiks min / 60 * 20 * 0.15
    pecapstradeElektribaEur = (reliefTimePerMin / 60) * 20 * 0.15
    pecapstradeElektribaEur = pecapstradeElektribaEur.toFixed(2)
    pecapstradeElektribaEur = Number(pecapstradeElektribaEur)

    // pecapstrade1VisparejasIzmaksas = (mekle ievadi no saraksta Iespiedmasinas visp.izmaksas EUR/h) * (Pieregulesanas Laiks Min 1 + Razosanas laiks min 1 ) / 60
    pecapstrade1VisparejasIzmaksas = (reliefTimePerMin + pecapstrade1RazosanasLaiksMin) / 60

    // razosanas izmaksas = materiala izmaksas eur + visparejas izmaksas + VC  + elektriba
    razosanasIzmaksas = materialaIzmaksasEur + visparejasIzmaksas + VC + elektriba

    /* Kopejas izmaksas = razosanas izmaksas 
                                + 2. iespiedmasina ( Visparejas izmaksas eur)
                                + 3. iespiedmasina (Visparejas izmaksas eur)
                                + 2. iespiedmasina (Eletriba Eur) 
                                + 3. iespiedmasina (Elektriba Eur) 
                                + 2. iespiedmasina (Materiala izmaskas EUR) 
                                + 3. iespiedmasina (Materiala izmaksas EUR) 
                            
                                + 1. Pecapstrade (Visparejas izmaksas) 
                                + 2. Pecapstrade (Visparejas izmaksas) 
                                + 3. Pecapstrade (Visparejas izmaksas)
                                + 1. Pecapstrade (Elektriba Eur) 
                                + 2. Pecapstrade (Elektriba Eur) 
                                + 3. Pecapstrade (Elektriba Eur) 
                                + 1. Pecapstrade (Materiala izmaksas EUR) 
                                + 2. Pecapstrade (Materiala izmaksas EUR) 
                                + 3. Pecapstrade (Materiala izmaksas EUR) 
                                
                                + produkcijasKomplektesanaVisparejasIzmaksas (Visparejas izmaksas) 
                                + produkcijasKomplektesanaElektribaEur (Visparejas izmaksas) 
                                + produkcijasKomplektesana2VisparejasIzmaksas (Elektriba Eur) 
                                + produkcijasKomplektesana2ElektribaEur (Elektriba Eur) 
                            
                                + Transports
                                */

    if (foilCount > 0) {
      //hotfoil production time per min
      hotprintProductionTimePerMin = tirieTekosieMetri / hotprintMeterPerMin
      hotprintProductionTimePerMin = Math.floor(hotprintProductionTimePerMin)

      //hotprintTotalCosts
      hotprintTotalCosts =
        (hotprintCostsPerH * (hotprintAdjustmentTimeMin + hotprintProductionTimePerMin)) / 60

      //hotprintEelectricity
      hotprintElectricity = (hotprintAdjustmentTimeMin / 60) * 20 * 0.15

      //hotprint adjustment m2
      hotprintAdjustmentM2 = (hotprintAdjustmentRunningMeters * formatWidth) / 1000

      //hotprintMaterial
      hotprintMaterialCosts = foilCosts * (hotprintAdjustmentM2 + tirieM2) * foilPercent

      //hotprint total costs
      hotprintCost = hotprintMaterialCosts + hotprintElectricity + hotprintTotalCosts
    }

    kopejasIzmaksas =
      razosanasIzmaksas +
      pecapstrade1VisparejasIzmaksas +
      productionMaterialCosts +
      pecapstradeElektribaEur +
      produkcijasKomplektesanaVisparejasIzmaksas +
      produkcijasKomplektesana2VisparejasIzmaksas +
      produkcijasKomplektesanaElektribaEur +
      produkcijasKomplektesana2ElektribaEur +
      hotprintCost +
      transports

    pardosanasSummaEur =
      kopejasIzmaksas *
      (1 +
        Number(clientsProfit / 100) +
        Number(extraProfitSlider / 100) +
        Number(userExtraPercent / 100))

    //cena par 1000 uzlimem eur
    // = pardosanas summa / etiketes daudzums * 1000
    console.log("--- BREAKDOWN ---")
    console.log("tirieM2:", tirieM2)
    console.log("tirieTekosieMetri:", tirieTekosieMetri)
    console.log("materialEurM2:", materialEurM2)
    console.log("materialaIzmaksasEur:", materialaIzmaksasEur)
    console.log("machineE+W+A:", machineElectricity, machineWorker, machineAmortization)
    console.log("pieregulesanasLaiksMin:", pieregulesanasLaiksMin)
    console.log("razosanasLaiksMin:", razosanasLaiksMin)
    console.log("visparejasIzmaksas:", visparejasIzmaksas)
    console.log("razosanasIzmaksas:", razosanasIzmaksas)
    console.log(
      "productionCosts:",
      productionCosts,
      "runningMin:",
      productionRunningMetersMin,
      "timePMin:",
      productionTimePerMinute,
    )
    console.log(
      "productionCosts2:",
      productionCosts2,
      "runningMin2:",
      productionRunningMetersMin2,
      "timePMin2:",
      productionTimePerMinute2,
    )
    console.log(
      "produkcijasKomplektesanaVisparejasIzmaksas:",
      produkcijasKomplektesanaVisparejasIzmaksas,
    )
    console.log(
      "produkcijasKomplektesana2VisparejasIzmaksas:",
      produkcijasKomplektesana2VisparejasIzmaksas,
    )

    cenaPar1000uzlimemEur = (pardosanasSummaEur / Number(totalCount)) * 1000

    cenaPar1000uzlimemEur = cenaPar1000uzlimemEur.toFixed(2)
    cenaPar1000uzlimemEur = Number(cenaPar1000uzlimemEur)

    let papiraPaterins = (tirieM2 + tehnologiskieZudumiM2).toFixed(2)
    papiraPaterins = Number(papiraPaterins)

    setWasCalculatePressed(false)

    return { cenaPar1000uzlimemEur, tiraisSvarsKg, papiraPaterins }
  }

  //runs render on on start
  useEffect(() => {
    const isAllZero = dynamicFixedPrice.some((obj) => obj.labelWeight === 0)
    if (rowBalance < 0 || rowBalance > 10) {
      setTooltipRowBalance(true)
    } else {
      setTooltipRowBalance(false)
    }
    if (
      isNaN(totalPrice) ||
      totalPrice === 0 ||
      productName === null ||
      rowBalance < -5 ||
      isAllZero
    ) {
      setSaveButtonDisabled(true)
    } else {
      setSaveButtonDisabled(false)
    }
  }, [totalPrice, productName, productFile, rowBalance, dynamicFixedPrice])

  //Tab data for viva
  const vivaTab = (
    <>
      <Row
        style={{
          paddingRight: 45,
          paddingLeft: 45,
          paddingBottom: 45,
        }}
        align="middle"
        gutter={[2, 5]}>
        <Col span={24}>
          <Space space="middle">
            <Tooltip
              placement="bottomLeft"
              title="This tells how many times a single job will go trought the machine (max. 3 times). Each time it goes trough, it add's extra machine-points, but in exchange the price will grow.">
              <InfoCircleOutlined />
            </Tooltip>
            <Text>How many times job goes trought ?</Text>
            <InputNumber
              value={howManyTimes}
              onChange={(value) => setHowManyTimes(value)}
              min={1}
              max={3}
              defaultValue={1}
            />
          </Space>
        </Col>
        <Col span={24}>
          <Space>
            <Tooltip
              placement="bottomLeft"
              title="This function allows to make the same job multiple times while lowering costs">
              <InfoCircleOutlined />
            </Tooltip>
            <Text>Sequential production</Text>
            <InputNumber value={secigaRazosana} onChange={setSecigaRazosa} />
          </Space>
        </Col>
        <Col span={24}>
          <Space>
            <Tooltip
              placement="bottomLeft"
              title="Machines-points are used to determine how many stations are left per one print. Maximum number of foils per print : 1">
              <InfoCircleOutlined />
            </Tooltip>
            <Text> Points Remaining : </Text>
            <Text style={pointsRemaining >= 1 ? { color: "#1890ff" } : { color: "#f5222d" }}>
              {" "}
              {pointsRemaining}
            </Text>
          </Space>
        </Col>
        <Divider></Divider>
        <Col span={6}>
          <Space>
            <Tooltip placement="bottom" title="How much process colors cmyk needed">
              <InfoCircleFilled />
            </Tooltip>
            <Text>CMYK</Text>
          </Space>
        </Col>
        <Col span={18}>
          <InputNumber
            value={cmykColors}
            max={pointsRemaining + cmykColors}
            min={0}
            style={{ width: "100%" }}
            onChange={(value) => setCmykColors(value)}
            placeholder="0"
          />
        </Col>

        <Col span={6}>
          <Text>Pantone</Text>
        </Col>
        <Col span={11}>
          <InputNumber
            value={pantoneColors}
            max={pointsRemaining + pantoneColors}
            min={0}
            style={{ width: "100%" }}
            onChange={(value) => setPantoneColors(value)}
            placeholder="0"
          />
        </Col>
        <Col span={7}>
          <InputNumber
            value={pantonePercent * 100}
            style={{ width: "100%" }}
            onChange={(value) => setPantonePercent(value / 100)}
            step={5}
            min={0}
            max={100}
            placeholder={0}
            addonAfter="%"
          />
        </Col>
        <Col span={6}>
          <Text>White</Text>
        </Col>
        <Col span={11}>
          <InputNumber
            value={coveringWCount}
            max={pointsRemaining + coveringWCount}
            min={0}
            style={{ width: "100%" }}
            onChange={(value) => setCoveringWCount(value)}
            placeholder="0"
          />
        </Col>
        <Col span={7}>
          <InputNumber
            value={coveringWPercent * 100}
            style={{ width: "100%" }}
            onChange={(value) => setCoveringWPercent(value / 100)}
            step={5}
            min={0}
            max={100}
            placeholder={0}
            addonAfter="%"
          />
        </Col>
        <Col span={6}>
          <Text>Varnish</Text>
        </Col>
        <Col span={18}>
          <Select
            disabled={pointsRemaining === 0 ? (varnishUse === 0 ? true : false) : false}
            value={varnishType}
            onChange={handleVarnish}
            style={{ width: "100%" }}
            placeholder="none"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }>
            {varnish &&
              varnish.map((varnish, id) => (
                <Option
                  id={varnish.id}
                  key={id}
                  costs={varnish.costs}
                  xpretp={varnish.xpretp}
                  value={varnish.type}
                  used={varnish.used}>
                  {varnish.type}
                </Option>
              ))}
          </Select>
        </Col>

        <Col span={6}>
          <Text>Silver/Gold</Text>
        </Col>
        <Col span={11}>
          <InputNumber
            value={goldOrSilver}
            max={pointsRemaining + goldOrSilver}
            min={0}
            style={{ width: "100%" }}
            onChange={(value) => setGoldOrSilver(value)}
            placeholder="0"
          />
        </Col>
        <Col span={7}>
          <InputNumber
            value={goldOrSilverPercent * 100}
            style={{ width: "100%" }}
            onChange={(value) => setGoldOrSilverPercent(value / 100)}
            step={5}
            min={0}
            max={100}
            placeholder={0}
            addonAfter="%"
          />
        </Col>
        <Col span={6}>
          <Text>Relief</Text>
        </Col>
        <Col span={18}>
          <Select
            disabled={pointsRemaining === 0 ? (selectedReliefUse === 0 ? true : false) : false}
            value={selectedReliefValue}
            onChange={handleRelief}
            style={{ width: "100%" }}
            placeholder="no"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }>
            {relief &&
              relief.map((relief, id) => (
                <Option
                  id={relief.id}
                  key={id}
                  meters={relief.meters}
                  runningMeters={relief.runningMeters}
                  timePerMin={relief.timePerMin}
                  value={relief.value}>
                  {relief.tag}
                </Option>
              ))}
          </Select>
        </Col>
        <Col span={6}>
          <Text>Foil</Text>
        </Col>
        <Col span={5}>
          <InputNumber
            value={foilCount}
            max={pointsRemaining === 0 ? (foilCount === 1 ? 1 : 0) : 1}
            min={0}
            style={{ width: "100%" }}
            onChange={(value) => setFoilCount(value)}
            placeholder="0"
          />
        </Col>
        <Col span={6}>
          <Select
            value={foilColor}
            onChange={handleFoil}
            style={{ width: "100%" }}
            placeholder="none"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }>
            {foil &&
              foil.map((foil, id) => (
                <Option id={foil.id} key={id} costs={foil.costs} value={foil.color}>
                  {foil.color}
                </Option>
              ))}
          </Select>
        </Col>
        <Col span={7}>
          <InputNumber
            value={foilPercent * 100}
            style={{ width: "100%" }}
            onChange={(value) => setFoilPercent(value / 100)}
            step={5}
            min={0}
            max={100}
            placeholder={0}
            addonAfter="%"
          />
        </Col>
        <Divider orientation="middle"></Divider>
        <Col span={24}>
          <Space direction="vertical" size={0} style={{ display: "flex" }}>
            <Space align="center" style={{ display: "flex", justifyContent: "space-between" }}>
              <Text>Pantone</Text>
              <Progress
                steps={10}
                percent={Number.parseFloat(pantonePercent * 100).toFixed(0)}
                status="active"
              />
            </Space>
            <Space align="center" style={{ display: "flex", justifyContent: "space-between" }}>
              <Text>Covering White</Text>
              <Progress
                steps={10}
                percent={Number.parseFloat(coveringWPercent * 100).toFixed(0)}
                status="active"
              />
            </Space>
            <Space align="center" style={{ display: "flex", justifyContent: "space-between" }}>
              <Text>Silver/Gold</Text>
              <Progress
                steps={10}
                percent={Number.parseFloat(goldOrSilverPercent * 100).toFixed(0)}
                status="active"
              />
            </Space>
            <Space align="center" style={{ display: "flex", justifyContent: "space-between" }}>
              <Text>Foil</Text>
              <Progress
                steps={10}
                percent={Number.parseFloat(foilPercent * 100).toFixed(0)}
                status="active"
              />
            </Space>
          </Space>
        </Col>
      </Row>
    </>
  )
  const arsomaTab = (
    <>
      <Row
        style={{
          paddingRight: 45,
          paddingLeft: 45,
          paddingBottom: 45,
        }}
        align="middle"
        gutter={[2, 5]}>
        <Col span={24}>
          <Space>
            <Tooltip
              placement="bottomLeft"
              title="This function allows to make the same job multiple times while lowering costs">
              <InfoCircleOutlined />
            </Tooltip>
            <Text>Sequential production</Text>
            <InputNumber value={secigaRazosana} onChange={setSecigaRazosa} />
          </Space>
        </Col>
        <Col span={24}>
          <Space>
            <Tooltip
              placement="bottomLeft"
              title="Machines-points are used to determine how many stations are left per one print. Maximum number of foils per print : 1">
              <InfoCircleOutlined />
            </Tooltip>
            <Text> Points Remaining : </Text>
            <Text style={pointsRemaining >= 1 ? { color: "#1890ff" } : { color: "#f5222d" }}>
              {pointsRemaining}
            </Text>
          </Space>
        </Col>
        <Divider></Divider>

        <Col span={6}>
          <Space>
            <Tooltip placement="bottom" title="How much process colors cmyk needed">
              <InfoCircleFilled />
            </Tooltip>
            <Text>CMYK</Text>
          </Space>
        </Col>
        <Col span={18}>
          <InputNumber
            value={cmykColors}
            max={pointsRemaining + cmykColors}
            min={0}
            style={{ width: "100%" }}
            onChange={(value) => setCmykColors(value)}
            placeholder="0"
          />
        </Col>

        <Col span={6}>
          <Text>Pantone</Text>
        </Col>
        <Col span={11}>
          <InputNumber
            value={pantoneColors}
            max={pointsRemaining + pantoneColors}
            min={0}
            style={{ width: "100%" }}
            onChange={(value) => setPantoneColors(value)}
            placeholder="0"
          />
        </Col>
        <Col span={7}>
          <InputNumber
            value={pantonePercent * 100}
            style={{ width: "100%" }}
            onChange={(value) => setPantonePercent(value / 100)}
            step={5}
            min={0}
            max={100}
            placeholder={0}
            addonAfter="%"
          />
        </Col>
        <Col span={6}>
          <Text>White</Text>
        </Col>
        <Col span={11}>
          <InputNumber
            value={coveringWCount}
            max={pointsRemaining + coveringWCount}
            min={0}
            style={{ width: "100%" }}
            onChange={(value) => setCoveringWCount(value)}
            placeholder="0"
          />
        </Col>
        <Col span={7}>
          <InputNumber
            value={coveringWPercent * 100}
            style={{ width: "100%" }}
            onChange={(value) => setCoveringWPercent(value / 100)}
            step={5}
            min={0}
            max={100}
            placeholder={0}
            addonAfter="%"
          />
        </Col>
        <Col span={6}>
          <Text>Varnish</Text>
        </Col>
        <Col span={18}>
          <Select
            disabled={pointsRemaining === 0 ? (varnishUse === 0 ? true : false) : false}
            value={varnishType}
            onChange={handleVarnish}
            style={{ width: "100%" }}
            placeholder="none"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }>
            {varnish &&
              varnish.map((varnish, id) => (
                <Option
                  id={varnish.id}
                  key={id}
                  costs={varnish.costs}
                  xpretp={varnish.xpretp}
                  value={varnish.type}
                  used={varnish.used}>
                  {varnish.type}
                </Option>
              ))}
          </Select>
        </Col>

        <Col span={6}>
          <Text>Silver/Gold</Text>
        </Col>
        <Col span={11}>
          <InputNumber
            value={goldOrSilver}
            max={pointsRemaining + goldOrSilver}
            min={0}
            style={{ width: "100%" }}
            onChange={(value) => setGoldOrSilver(value)}
            placeholder="0"
          />
        </Col>
        <Col span={7}>
          <InputNumber
            value={goldOrSilverPercent * 100}
            style={{ width: "100%" }}
            onChange={(value) => setGoldOrSilverPercent(value / 100)}
            step={5}
            min={0}
            max={100}
            placeholder={0}
            addonAfter="%"
          />
        </Col>

        <Divider orientation="middle"></Divider>
        <Col span={24}>
          <Space direction="vertical" size={0} style={{ display: "flex" }}>
            <Space align="center" style={{ display: "flex", justifyContent: "space-between" }}>
              <Text>Pantone</Text>
              <Progress
                steps={10}
                percent={Number.parseFloat(pantonePercent * 100).toFixed(0)}
                status="active"
              />
            </Space>
            <Space align="center" style={{ display: "flex", justifyContent: "space-between" }}>
              <Text>Covering White</Text>
              <Progress
                steps={10}
                percent={Number.parseFloat(coveringWPercent * 100).toFixed(0)}
                status="active"
              />
            </Space>
            <Space align="center" style={{ display: "flex", justifyContent: "space-between" }}>
              <Text>Silver/Gold</Text>
              <Progress
                steps={10}
                percent={Number.parseFloat(goldOrSilverPercent * 100).toFixed(0)}
                status="active"
              />
            </Space>
            <Space align="center" style={{ display: "flex", justifyContent: "space-between" }}>
              <Text>Foil</Text>
              <Progress
                steps={10}
                percent={Number.parseFloat(foilPercent * 100).toFixed(0)}
                status="active"
              />
            </Space>
          </Space>
        </Col>
      </Row>
    </>
  )

  //content if loading from template
  if (globalLoading) {
    return (
      <>
        <div className="spinner-container-custom">
          <Spin tip="Loading Data for Price" size="large" />
        </div>
      </>
    )
  }

  //main content
  return (
    <div>
      <Space align="center" style={{ marginBottom: 15 }}>
        <Title level={3}>
          <CalculatorOutlined />
          <Divider type="vertical" /> Calculations
        </Title>
        <Divider type="vertical" />
        <Text>New job?</Text>
        <Select
          size="small"
          value={newJob ? "Yes" : "No"}
          style={{
            width: 120,
          }}
          options={[
            {
              value: false,
              label: "No",
            },
            {
              value: true,
              label: "Yes",
            },
          ]}
          onChange={handleNewJob}
        />
        <Divider type="vertical" />
        <Checkbox onChange={handleAdminReview}>Admin review?</Checkbox>
      </Space>

      <Row justify="space-evenly">
        <Col
          style={{
            paddingRight: 15,
            paddingLeft: 15,
            background: "white",
            borderRadius: "3px",
          }}
          className="gutter-row"
          span={7}>
          <Divider orientation="middle">Main settings</Divider>
          <Row style={{ paddingBottom: "20px" }} align="middle" gutter={[2, 5]}>
            <Col span={10}>
              <Text>
                Machine{" "}
                {selectedMachine === null ? "" : <CheckCircleFilled style={{ color: "green" }} />}
              </Text>
            </Col>
            <Col span={14}>
              <Select
                onChange={handleMachine}
                style={{ width: "100%" }}
                placeholder="Machine"
                value={selectedMachine && selectedMachine}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                filterSort={(optionA, optionB) =>
                  optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                }>
                {machines &&
                  machines.map((machine, index) => (
                    <Option
                      id={machine.id}
                      key={machine.key}
                      alsm={machine.alsm}
                      worker={machine.costs.worker}
                      electricity={machine.costs.electricity}
                      amortization={machine.costs.amortization}
                      speed={machine.speed}
                      stations={machine.stations}
                      value={machine.machine}>
                      {machine.machine}
                    </Option>
                  ))}
              </Select>
            </Col>
            <SelectClient
              selectedClient={selectedClient}
              handleClient={handleClient}
              loadingClients={loadingClients}
              clients={clients}
              user={user}
              setClients={setClients}
              admin={admin}
              semiAdmin={semiAdmin}
              devSpecialist={devSpecialist}
              setLoadingClients={setLoadingClients}
              selectedMachine={selectedMachine}
            />

            <SelectProductType setProductType={setProductType} productType={productType} />

            <Col span={10}>
              <Text>
                Product{" "}
                {productName === null ? "" : <CheckCircleFilled style={{ color: "green" }} />}
              </Text>
            </Col>
            <Col span={14}>
              <Input
                allowClear
                value={productName && productName}
                onChange={(event) => setProductName(event.target.value)}
                placeholder="Product name"
                style={{ width: "100%" }}
              />
            </Col>

            <Col span={10}>
              <Text>
                Filter Group{" "}
                {hasFilterGroup ? <CheckCircleFilled style={{ color: "green" }} /> : ""}
              </Text>
            </Col>
            <Col span={14}>
              <Select
                style={{ width: "100%" }}
                onChange={handleFilterGroups}
                loading={filterGroupsLoading}
                defaultValue="none"
                placeholder="Filter group"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                filterSort={(optionA, optionB) =>
                  optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                }>
                <Option
                  id="none"
                  key={"none"}
                  hasFilter={false}
                  title={null}
                  existingChildren={[]}
                  value={"none"}>
                  {"none"}
                </Option>
                {allFilterGroups &&
                  allFilterGroups.map((item, id, hehe) => (
                    <Option
                      id={item.id}
                      key={id}
                      hasFilter={true}
                      title={item.title}
                      existingChildren={item.children}
                      value={item.id}>
                      {item.title}
                    </Option>
                  ))}
              </Select>
            </Col>

            {returnMachineFields()}
          </Row>
        </Col>

        <Col
          style={{
            paddingRight: 15,
            paddingLeft: 15,
            background: "white",
            borderRadius: "3px",
          }}
          className="gutter-row"
          span={10}>
          {selectedMachine == null ? (
            <>
              <Divider orientation="middle">Please select the machine...</Divider>
              <Skeleton />
            </>
          ) : (
            <>
              <Divider orientation="middle">Configurations for {selectedMachine}</Divider>
              <Tabs
                centered
                activeKey={activeKey}
                items={[
                  {
                    label: `Arsoma`,
                    key: "2",
                    children: arsomaTab,
                    disabled: true,
                  },
                  {
                    label: `Cutter`,
                    key: "0",
                    children: `There are no settings for cutter calculation`,
                    disabled: true,
                  },
                  {
                    label: `Viva`,
                    key: "1",
                    children: vivaTab,
                    disabled: true,
                  },
                  {
                    label: `Tape`,
                    key: "3",
                    children: (
                      <TapeTab
                        tapeColorCount={tapeColorCount}
                        setTapeColorCount={setTapeColorCount}
                      />
                    ),
                    disabled: true,
                  },
                ]}
              />
            </>
          )}
        </Col>
        <Col
          style={{
            background: "white",
            borderRadius: "3px",
          }}
          className="gutter-row"
          span={7}>
          <Divider>Prices</Divider>
          {returnCorrectPriceTabs()}
        </Col>
      </Row>
    </div>
  )
}
